webpackJsonp([0],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  this["$style"] = __webpack_require__(239)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(97),
  /* template */
  __webpack_require__(357),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = init;
/* harmony export (immutable) */ __webpack_exports__["e"] = reset;
/* unused harmony export rejoin */
/* harmony export (immutable) */ __webpack_exports__["d"] = join;
/* unused harmony export watch */
/* harmony export (immutable) */ __webpack_exports__["c"] = create;
/* harmony export (immutable) */ __webpack_exports__["b"] = send;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__package_json__ = __webpack_require__(362);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__package_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__package_json__);



console.log(__WEBPACK_IMPORTED_MODULE_1__package_json__["version"]);

var ws = void 0;
var store = void 0;

function connect(name, args) {
    store.commit('SET_ERROR', null);

    var base = void 0;
    if (location.hostname == 'localhost') base = 'http://' + location.hostname + ':8081/';else base = 'https://api.mfro.me/secret-hitler/';

    var url = base.replace('http', 'ws');

    ws = new WebSocket(url);

    ws.addEventListener('message', function (e) {
        var msg = JSON.parse(e.data);

        if (msg.name == 'state') {
            if (store.getters.connection != 'OPEN') store.commit('SET_CONNECTION', 'OPEN');

            store.commit('SET_GAME', msg.args);
        }

        if (msg.name == 'result') {
            store.commit('POST_RESULT', msg.args);
        }

        if (msg.name == 'error') {
            if (msg.args.name == 'VERSION') {
                location.reload(true);
            }

            store.commit('SET_ERROR', args.error);
            console.log('error:', msg.args);
            dispose();
        }

        console.log(msg);
    });

    ws.addEventListener('open', function (e) {
        if (ws == null) return;
        if (ws.readyState != WebSocket.OPEN) return;

        ws.send(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({
            name: name,
            version: __WEBPACK_IMPORTED_MODULE_1__package_json__["version"],
            args: args
        }));
    });

    ws.addEventListener('close', function (e) {
        dispose();
    });

    ws.addEventListener('error', function (e) {
        console.error(e);
        dispose();
    });

    store.commit('SET_CONNECTION', 'CONNECTING');
}

function init(s) {
    store = s;
    loadRejoinInfo();
}

function reset() {
    dispose();
}

function rejoin(game, id) {
    connect('REJOIN', {
        game: game,
        id: id
    });
}

function join(game, name) {
    connect('JOIN', {
        game: game,
        name: name
    });
}

function watch(game) {
    connect('WATCH', {
        game: game
    });
}

function create(name) {
    connect('CREATE', {
        name: name
    });
}

function send(name, args) {
    ws.send(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({
        name: name,
        args: args
    }));
}

function dispose() {
    if (ws && ws.readyState == WebSocket.OPEN) ws.close();

    store.commit('SET_CONNECTION', null);

    var game = store.getters.game;
    if (game && game.state == 'COMPLETED') return;

    localStorage.removeItem('secret-hitler/rejoin-info');
    store.commit('SET_GAME', null);
    ws = null;
}

function loadRejoinInfo() {
    try {
        var raw = localStorage.getItem('secret-hitler/rejoin-info');
        if (!raw) return;
        var info = JSON.parse(raw);
        if (!info || !(info instanceof Array)) return;

        rejoin(info[0], info[1]);
    } catch (e) {
        localStorage.removeItem('secret-hitler/rejoin-info');
    }
}

window.addEventListener('keydown', function (e) {
    if (e.keyCode == 116) {
        if (store.getters.localPlayer && store.getters.game.state != 'LOBBY') {
            e.preventDefault();
            try {
                localStorage.setItem('secret-hitler/player-id', state.getters.localPlayer.id);
            } catch (e) {}

            setTimeout(function () {
                window.location.reload();
            }, 500);
        }
    }
});

/***/ }),
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = getMembershipCard;
/* harmony export (immutable) */ __webpack_exports__["d"] = getRoleCard;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return ja_card; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return nein_card; });
/* unused harmony export voting_card */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return liberal_policy; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return fascist_policy; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_membership_back_png__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_membership_back_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__assets_membership_back_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_membership_fascist_png__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_membership_fascist_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__assets_membership_fascist_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_membership_liberal_png__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_membership_liberal_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__assets_membership_liberal_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_role_back_png__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_role_back_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__assets_role_back_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_role_fascist0_png__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_role_fascist0_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__assets_role_fascist0_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_role_fascist1_png__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_role_fascist1_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__assets_role_fascist1_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_role_fascist2_png__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_role_fascist2_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__assets_role_fascist2_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_role_hitler0_png__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_role_hitler0_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__assets_role_hitler0_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_role_liberal1_png__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_role_liberal1_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__assets_role_liberal1_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assets_role_liberal2_png__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assets_role_liberal2_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__assets_role_liberal2_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__assets_role_liberal3_png__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__assets_role_liberal3_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__assets_role_liberal3_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__assets_role_liberal4_png__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__assets_role_liberal4_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__assets_role_liberal4_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__assets_role_liberal5_png__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__assets_role_liberal5_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__assets_role_liberal5_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__assets_vote_back_png__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__assets_vote_back_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__assets_vote_back_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__assets_vote_ja_png__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__assets_vote_ja_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__assets_vote_ja_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__assets_vote_nein_png__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__assets_vote_nein_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__assets_vote_nein_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__assets_policy_back_png__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__assets_policy_back_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__assets_policy_back_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__assets_policy_liberal_png__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__assets_policy_liberal_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__assets_policy_liberal_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__assets_policy_fascist_png__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__assets_policy_fascist_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__assets_policy_fascist_png__);

























var role_fascist = [__WEBPACK_IMPORTED_MODULE_4__assets_role_fascist0_png__, __WEBPACK_IMPORTED_MODULE_5__assets_role_fascist1_png__, __WEBPACK_IMPORTED_MODULE_6__assets_role_fascist2_png__];
var role_liberal = [__WEBPACK_IMPORTED_MODULE_8__assets_role_liberal1_png__, __WEBPACK_IMPORTED_MODULE_9__assets_role_liberal2_png__, __WEBPACK_IMPORTED_MODULE_10__assets_role_liberal3_png__, __WEBPACK_IMPORTED_MODULE_11__assets_role_liberal4_png__, __WEBPACK_IMPORTED_MODULE_12__assets_role_liberal5_png__, __WEBPACK_IMPORTED_MODULE_12__assets_role_liberal5_png__];

function getMembershipCard(role) {
    if (role == 'FASCIST' || role == 'HITLER') return { back: __WEBPACK_IMPORTED_MODULE_0__assets_membership_back_png__, front: __WEBPACK_IMPORTED_MODULE_1__assets_membership_fascist_png__ };

    if (role == 'LIBERAL') return { back: __WEBPACK_IMPORTED_MODULE_0__assets_membership_back_png__, front: __WEBPACK_IMPORTED_MODULE_2__assets_membership_liberal_png__ };

    return alert('something went wrong :/');
}

function getRoleCard(role) {
    if (role == 'HITLER') return { back: __WEBPACK_IMPORTED_MODULE_3__assets_role_back_png__, front: __WEBPACK_IMPORTED_MODULE_7__assets_role_hitler0_png__ };

    if (role == 'FASCIST') return { back: __WEBPACK_IMPORTED_MODULE_3__assets_role_back_png__, front: rand(role_fascist) };

    if (role == 'LIBERAL') return { back: __WEBPACK_IMPORTED_MODULE_3__assets_role_back_png__, front: rand(role_liberal) };

    return alert('something went wrong :/');
}

var ja_card = { back: __WEBPACK_IMPORTED_MODULE_13__assets_vote_back_png__, front: __WEBPACK_IMPORTED_MODULE_14__assets_vote_ja_png__ };
var nein_card = { back: __WEBPACK_IMPORTED_MODULE_13__assets_vote_back_png__, front: __WEBPACK_IMPORTED_MODULE_15__assets_vote_nein_png__ };
var voting_card = { back: __WEBPACK_IMPORTED_MODULE_15__assets_vote_nein_png__, front: __WEBPACK_IMPORTED_MODULE_14__assets_vote_ja_png__ };

var liberal_policy = { back: __WEBPACK_IMPORTED_MODULE_16__assets_policy_back_png__, front: __WEBPACK_IMPORTED_MODULE_17__assets_policy_liberal_png__ };
var fascist_policy = { back: __WEBPACK_IMPORTED_MODULE_16__assets_policy_back_png__, front: __WEBPACK_IMPORTED_MODULE_18__assets_policy_fascist_png__ };

function rand(list) {
    return list[Math.floor(Math.random() * list.length)];
}

/***/ }),
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  this["$style"] = __webpack_require__(232)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(92),
  /* template */
  __webpack_require__(350),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  this["$style"] = __webpack_require__(226)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(94),
  /* template */
  __webpack_require__(344),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  this["$style"] = __webpack_require__(233)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(100),
  /* template */
  __webpack_require__(351),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/liberal5.3557497.png";

/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  this["$style"] = __webpack_require__(195)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(99),
  /* template */
  __webpack_require__(311),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/back.921b558.png";

/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/fascist.99e0612.png";

/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/liberal.fc85aaa.png";

/***/ }),
/* 66 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 67 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 68 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/back.9894677.png";

/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/fascist0.7369dd6.png";

/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/fascist1.851bcd6.png";

/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/fascist2.2c0091f.png";

/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/hitler0.62814fe.png";

/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/liberal1.876a597.png";

/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/liberal2.d567cfc.png";

/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/liberal3.8cf62d3.png";

/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/liberal4.94a45c7.png";

/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/back.163b685.png";

/***/ }),
/* 79 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/nein.690673b.png";

/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  this["$style"] = __webpack_require__(230)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(101),
  /* template */
  __webpack_require__(348),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  this["$style"] = __webpack_require__(203)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(104),
  /* template */
  __webpack_require__(320),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  this["$style"] = __webpack_require__(200)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(130),
  /* template */
  __webpack_require__(316),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 84 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_timers__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_timers___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_timers__);




var container = void 0;
var waiting = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve();
var context = __webpack_require__(363);

var _iteratorNormalCompletion = true;
var _didIteratorError = false;
var _iteratorError = undefined;

try {
    for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(context.keys()), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var key = _step.value;

        var path = context(key);

        loadImage(path);
    }
} catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
} finally {
    try {
        if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
        }
    } finally {
        if (_didIteratorError) {
            throw _iteratorError;
        }
    }
}

function loadImage(path) {
    if (!container) {
        container = document.createElement('div');
        container.style.opacity = '0';
        container.style.position = 'absolute';
        container.style.pointerEvents = 'none';
        container.style.top = '0';
        container.style.left = '0';
        container.style.right = '0';
        container.style.bottom = '0';
        container.style.overflow = 'hidden';
        document.body.appendChild(container);
    }

    var tmp = path.slice(0, 100);

    return waiting = waiting.then(function () {
        return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve) {
            var image = new Image();
            image.src = path;

            image.onload = function () {
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_timers__["setTimeout"])(resolve, 100);
            };

            image.onerror = function () {
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_timers__["setTimeout"])(resolve, 100);
            };

            image.style.position = 'absolute';
            container.appendChild(image);
        });
    });
}

/***/ }),
/* 85 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export isDebug */
/* unused harmony export PLAYERS */
/* unused harmony export GAME_LOBBY */
/* unused harmony export GAME_NOMINATING_SELF */
/* unused harmony export GAME_NOMINATING_OTHER */
/* unused harmony export GAME_VOTING_NOT_DONE */
/* unused harmony export GAME_VOTING_DONE */
/* unused harmony export GAME_DEAD_SELF */
/* unused harmony export GAME_DEAD_OTHER */
/* unused harmony export GAME_LIBERAL_POLICY_VICTORY */
/* unused harmony export GAME_FASCIST_POLICY_VICTORY */
/* unused harmony export GAME_LIBERAL_HITLER_VICTORY */
/* unused harmony export GAME_FASCIST_HITLER_VICTORY */
/* unused harmony export VOTE_EVENT */
/* unused harmony export POLICY_EVENT */
/* unused harmony export VETO_AGREE_EVENT */
/* unused harmony export VETO_DISAGREE_EVENT */
/* unused harmony export ASSASSINATION_EVENT */
/* harmony export (immutable) */ __webpack_exports__["a"] = init;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);

var isDebug = location.hostname == 'localhost';

var PLAYERS = [{
    id: 0,
    name: 'Player 0',
    isLocalPlayer: true,
    isAlive: true
}, {
    id: 1,
    name: 'Player 1',
    isLocalPlayer: false,
    isAlive: true
}, {
    id: 2,
    name: 'Player 2',
    isLocalPlayer: false,
    isAlive: true
}, {
    id: 3,
    name: 'Player 3',
    isLocalPlayer: false,
    isAlive: true
}, {
    id: 4,
    name: 'Player 4',
    isLocalPlayer: false,
    isAlive: true
}];

function make_game(args, mapper) {
    mapper = mapper || function (p) {
        return {};
    };
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({
        log: [],
        name: 69,
        players: PLAYERS.map(function (p) {
            var r = mapper(p);
            if (r == null) return null;
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, p, r);
        }).filter(function (p) {
            return p;
        }),
        boardState: {
            liberals: 3,
            fascists: 3,
            voteFailures: 1,
            drawSize: 12,
            discardSize: 0
        }
    }, args);
}

var GAME_LOBBY = make_game({
    state: 'LOBBY'
}, function (p) {
    return {
        isReady: false
    };
});

var GAME_NOMINATING_SELF = make_game({
    state: 'NOMINATING',
    nomination: {
        president: 0
    }
});

var GAME_NOMINATING_OTHER = make_game({
    state: 'NOMINATING',
    nomination: {
        president: 1
    }
});

var GAME_VOTING_NOT_DONE = make_game({
    state: 'VOTING',
    nomination: {
        president: 1,
        chancellor: 2
    }
}, function (p) {
    return {
        hasVoted: false
    };
});

var GAME_VOTING_DONE = make_game({
    state: 'VOTING',
    nomination: {
        president: 1,
        chancellor: 2
    }
}, function (p) {
    return {
        hasVoted: p.id % 2 == 0
    };
});

var GAME_DEAD_SELF = make_game({
    state: 'VOTING',
    nomination: {
        president: 1,
        chancellor: 2
    }
}, function (p) {
    return {
        hasVoted: p.id % 2 == 1 || p.id == 0,
        isAlive: p.id != 0
    };
});

var GAME_DEAD_OTHER = make_game({
    state: 'VOTING',
    nomination: {
        president: 1,
        chancellor: 3
    }
}, function (p) {
    return {
        hasVoted: p.id % 2 == 1,
        isAlive: p.id != 2
    };
});

var GAME_LIBERAL_POLICY_VICTORY = make_game({
    state: 'COMPLETED',
    victory: 'LIBERAL_POLICY'
});

var GAME_FASCIST_POLICY_VICTORY = make_game({
    state: 'COMPLETED',
    victory: 'FASCIST_POLICY'
});

var GAME_LIBERAL_HITLER_VICTORY = make_game({
    state: 'COMPLETED',
    victory: 'LIBERAL_HITLER'
});

var GAME_FASCIST_HITLER_VICTORY = make_game({
    state: 'COMPLETED',
    victory: 'FASCIST_HITLER'
});

var VOTE_EVENT = {
    name: 'vote',
    args: {
        pass: false,
        president: 0,
        chancellor: 2,
        votes: {
            ja: [],
            nein: [0, 1, 2, 3, 4]
        }
    }
};

var POLICY_EVENT = {
    name: 'policy',
    args: {
        policy: 'LIBERAL',
        government: {
            president: 0,
            chancellor: 2
        }
    }
};

var VETO_AGREE_EVENT = {
    name: 'veto',
    args: {
        agree: true,
        president: 0,
        chancellor: 2
    }
};

var VETO_DISAGREE_EVENT = {
    name: 'veto',
    args: {
        agree: false,
        president: 0,
        chancellor: 2
    }
};

var ASSASSINATION_EVENT = {
    name: 'assassination',
    args: {
        president: 0,
        target: 2
    }
};

function init(store) {
    if (!isDebug) return;

    // store.commit('SET_GAME', GAME_VOTING_DONE);
}

/***/ }),
/* 86 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_raven_js__ = __webpack_require__(248);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_raven_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_raven_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_raven_js_plugins_vue__ = __webpack_require__(244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_raven_js_plugins_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_raven_js_plugins_vue__);




if (true) {
    __WEBPACK_IMPORTED_MODULE_1_raven_js___default.a.config('https://fa95c43db8564b969540265a8aa66564@sentry.io/257051').addPlugin(__WEBPACK_IMPORTED_MODULE_2_raven_js_plugins_vue___default.a, __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]).install();
}

/***/ }),
/* 87 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__directives__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__style__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuetify__ = __webpack_require__(361);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuetify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vuetify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mfro_vue_specific_css__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mfro_vue_specific_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__mfro_vue_specific_css__);









__WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_4_vuetify___default.a);
__WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_5__mfro_vue_specific_css___default.a);

// document.ontouchmove = function (event) {
//     event.preventDefault();
// }

/***/ }),
/* 88 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(359);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__player_ui_routes_HomeView__ = __webpack_require__(302);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__player_ui_routes_HomeView___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__player_ui_routes_HomeView__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__player_ui_routes_LogView__ = __webpack_require__(306);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__player_ui_routes_LogView___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__player_ui_routes_LogView__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__player_ui_routes_OptionsView__ = __webpack_require__(307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__player_ui_routes_OptionsView___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__player_ui_routes_OptionsView__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__player_ui_routes_LogDetailsView__ = __webpack_require__(305);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__player_ui_routes_LogDetailsView___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__player_ui_routes_LogDetailsView__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__player_ui_routes_AssignmentView__ = __webpack_require__(300);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__player_ui_routes_AssignmentView___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__player_ui_routes_AssignmentView__);









var routes = [{
    path: '/options',
    component: __WEBPACK_IMPORTED_MODULE_4__player_ui_routes_OptionsView___default.a
}, {
    path: '/role',
    component: __WEBPACK_IMPORTED_MODULE_6__player_ui_routes_AssignmentView___default.a
}, {
    path: '/log/:index',
    component: __WEBPACK_IMPORTED_MODULE_5__player_ui_routes_LogDetailsView___default.a,
    props: true,
    meta: {
        back: '/log'
    }
}, {
    path: '/log',
    component: __WEBPACK_IMPORTED_MODULE_3__player_ui_routes_LogView___default.a
}, {
    path: '/home',
    component: __WEBPACK_IMPORTED_MODULE_2__player_ui_routes_HomeView___default.a
}, {
    path: '/',
    redirect: '/home'
}];

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
    routes: routes
}));

/***/ }),
/* 89 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_game__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store_connection__ = __webpack_require__(143);






var state = {};

var getters = {};

var mutations = {};

var actions = {
    reset: function reset(_ref) {
        var commit = _ref.commit;

        commit('RESET_GAME');
        commit('RESET_CONNECTION');
    }
};

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* default */].Store({
    state: state,
    getters: getters,
    mutations: mutations,
    actions: actions,
    modules: {
        game: __WEBPACK_IMPORTED_MODULE_2__store_game__,
        connection: __WEBPACK_IMPORTED_MODULE_3__store_connection__
    }
}));

/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  this["$style"] = __webpack_require__(192)
  __webpack_require__(241)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(103),
  /* template */
  __webpack_require__(308),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 91 */,
/* 92 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    props: {
        card: Object,
        value: Boolean,
        basis: { type: String, default: 'short' },
        noBorder: { type: Boolean, default: false },
        horizontal: { type: Boolean, default: false }
    },

    data: function data() {
        return {
            style: {
                width: null,
                height: null
            },
            rotStyle: {
                width: null,
                height: null
            }
        };
    },


    computed: {
        frontStyle: function frontStyle() {
            return {
                backgroundImage: 'url(' + this.card.front + ')'
            };
        },
        backStyle: function backStyle() {
            return {
                backgroundImage: 'url(' + this.card.back + ')'
            };
        }
    },

    mounted: function mounted() {
        this.resize();
    },


    methods: {
        resize: function resize() {
            this.style.width = this.style.height = null;

            var box = this.$el.getBoundingClientRect();

            var ratio = 256 / 355;

            var width = void 0,
                height = void 0;
            if (this.horizontal) {
                if (this.basis == 'long') height = box.width * ratio;else width = box.height / ratio;
            } else {
                if (this.basis == 'long') width = box.height * ratio;else height = box.width / ratio;
            }

            this.style = {
                width: width ? Math.floor(width) + 'px' : null,
                height: height ? Math.floor(height) + 'px' : null
            };

            if (this.horizontal) {
                this.rotStyle = {
                    width: this.style.height || box.height + 'px',
                    height: this.style.width || box.width + 'px'
                };
            } else {
                this.rotStyle = {
                    width: this.style.width || box.width + 'px',
                    height: this.style.height || box.height + 'px'
                };
            }
        },
        onClick: function onClick() {
            this.$emit('input', !this.value);
        }
    }
});

/***/ }),
/* 93 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__card__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__card___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__card__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__cards__ = __webpack_require__(19);
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
    components: {
        Card: __WEBPACK_IMPORTED_MODULE_0__card___default.a
    },

    props: {
        role: String,
        basis: String,
        value: Boolean,
        horizontal: { type: Boolean, default: false }
    },

    computed: {
        card: function card() {
            return __WEBPACK_IMPORTED_MODULE_1__cards__["c" /* getMembershipCard */](this.role);
        }
    }
});

/***/ }),
/* 94 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__card__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__card___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__card__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__cards__ = __webpack_require__(19);
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
    components: {
        Card: __WEBPACK_IMPORTED_MODULE_0__card___default.a
    },

    props: {
        value: { type: Boolean, default: true },
        basis: String,
        policy: String,
        horizontal: { type: Boolean, default: false }
    },

    computed: {
        card: function card() {
            if (this.policy == 'LIBERAL') return __WEBPACK_IMPORTED_MODULE_1__cards__["a" /* liberal_policy */];

            if (this.policy == 'FASCIST') return __WEBPACK_IMPORTED_MODULE_1__cards__["b" /* fascist_policy */];
        }
    }
});

/***/ }),
/* 95 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__card__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__card___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__card__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__cards__ = __webpack_require__(19);
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
    components: {
        Card: __WEBPACK_IMPORTED_MODULE_0__card___default.a
    },

    props: {
        role: String,
        basis: String,
        value: Boolean,
        horizontal: { type: Boolean, default: false }
    },

    computed: {
        card: function card() {
            return __WEBPACK_IMPORTED_MODULE_1__cards__["d" /* getRoleCard */](this.role);
        }
    }
});

/***/ }),
/* 96 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__card__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__card___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__card__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__cards__ = __webpack_require__(19);
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
    components: {
        Card: __WEBPACK_IMPORTED_MODULE_0__card___default.a
    },

    props: {
        vote: { required: true },
        basis: String,
        horizontal: { type: Boolean, default: false }
    },

    computed: {
        card: function card() {
            if (this.vote) return __WEBPACK_IMPORTED_MODULE_1__cards__["e" /* ja_card */];

            return __WEBPACK_IMPORTED_MODULE_1__cards__["f" /* nein_card */];
        }
    }
});

/***/ }),
/* 97 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__plaque__ = __webpack_require__(269);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__plaque___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__plaque__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
    components: {
        Plaque: __WEBPACK_IMPORTED_MODULE_2__plaque___default.a
    },

    props: {
        government: { type: Object, default: null },
        president: { type: Object, default: null },
        chancellor: { type: Object, default: null }
    },

    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])({
        getPlayer: 'getPlayer'
    }), {
        pres: function pres() {
            var value = void 0;
            if (this.president) value = this.president;else if (this.government) value = this.government.president;

            if (typeof value == 'number') return this.getPlayer(value);

            return value;
        },
        chan: function chan() {
            var value = void 0;
            if (this.chancellor) value = this.chancellor;else if (this.government) value = this.government.chancellor;

            if (typeof value == 'number') return this.getPlayer(value);

            return value;
        }
    })
});

/***/ }),
/* 98 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    props: {
        type: { type: String, default: null },
        president: { type: Boolean, default: false },
        chancellor: { type: Boolean, default: false }
    },

    computed: {
        imageType: function imageType() {
            if (this.president) return 'president';
            if (this.chancellor) return 'chancellor';
            return this.type;
        }
    }
});

/***/ }),
/* 99 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
    props: {
        large: { type: Boolean, default: false },
        larger: { type: Boolean, default: false },
        filter: { type: Function, default: null }
    },

    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])({
        game: 'game',
        allPlayers: 'allPlayers',
        localPlayer: 'localPlayer'
    }), {
        options: function options() {
            var _this = this;

            return this.allPlayers.filter(function (p) {
                if (p.isAlive === false) return false;

                return !_this.filter || _this.filter(p);
            });
        }
    })
});

/***/ }),
/* 100 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
    props: {
        value: Object,
        filter: { type: Function, required: false }
    },

    data: function data() {
        return {
            isOpen: false
        };
    },


    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])({
        game: 'game',
        allPlayers: 'allPlayers',
        localPlayer: 'localPlayer'
    }), {
        options: function options() {
            var _this = this;

            var list = this.allPlayers.filter(function (p) {
                if (p.isAlive === false) return false;

                return !_this.filter || _this.filter(p);
            });

            return list;
        }
    }),

    methods: {
        select: function select(player) {
            this.isOpen = false;
            this.$emit('input', player);
        }
    }
});

/***/ }),
/* 101 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ui_cards_role__ = __webpack_require__(267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ui_cards_role___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__ui_cards_role__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ui_cards_membership__ = __webpack_require__(266);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ui_cards_membership___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__ui_cards_membership__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
    components: {
        RoleCard: __WEBPACK_IMPORTED_MODULE_2__ui_cards_role___default.a,
        MembershipCard: __WEBPACK_IMPORTED_MODULE_3__ui_cards_membership___default.a
    },

    data: function data() {
        return {
            roleFlipped: false,
            membershipFlipped: false
        };
    },


    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])({
        game: 'game',
        getPlayer: 'getPlayer',
        localPlayer: 'localPlayer'
    }), {
        assignment: function assignment() {
            return this.localPlayer.assignment;
        },
        hitler: function hitler() {
            if (!this.assignment.hitler) return null;
            return this.getPlayer(this.assignment.hitler);
        },
        fascists: function fascists() {
            if (!this.assignment.fascists) return null;
            return this.assignment.fascists.map(this.getPlayer);
        }
    })

});

/***/ }),
/* 102 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    props: {
        noHeader: { type: Boolean, default: false },
        noFooter: { type: Boolean, default: false }
    }
});

/***/ }),
/* 103 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__socket__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ui_cards_policy__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ui_cards_policy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__ui_cards_policy__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'SecretHitler',

    components: {
        PolicyCard: __WEBPACK_IMPORTED_MODULE_4__ui_cards_policy___default.a
    },

    data: function data() {
        return {
            drawer: false,
            navs: [{ icon: 'home', label: 'Home', path: '/home' }, { icon: 'person', label: 'Role', path: '/role' }, { icon: 'history', label: 'Game log', path: '/log' }, { icon: 'settings', label: 'Game options', path: '/options' }]
        };
    },


    computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])({
        game: 'game',
        results: 'results',
        localPlayer: 'localPlayer',

        route: 'router/route'
    }), {
        isStarted: function isStarted() {
            return this.game != null && this.game.state != 'LOBBY';
        },
        backDst: function backDst() {
            return this.$route.meta.back;
        }
    }),

    watch: {
        isStarted: function isStarted() {
            try {
                localStorage.setItem('secret-hitler/rejoin-info', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()([this.game.name, this.localPlayer.id]));
            } catch (e) {}
        }
    },

    methods: {
        back: function back() {
            this.$router.push(this.backDst);
        }
    }
});

/***/ }),
/* 104 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);


//
//
//
//

var regex = /([\w-]+)\/details.vue$/;
var context = __webpack_require__(364);
var components = {};

var _iteratorNormalCompletion = true;
var _didIteratorError = false;
var _iteratorError = undefined;

try {
    for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(context.keys()), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var key = _step.value;

        var match = regex.exec(key);
        var options = context(key);

        components['event-' + match[1] + '-details'] = options;
    }
} catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
} finally {
    try {
        if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
        }
    } finally {
        if (_didIteratorError) {
            throw _iteratorError;
        }
    }
}

/* harmony default export */ __webpack_exports__["default"] = ({
    components: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, components),

    props: {
        event: Object
    },

    computed: {
        component: function component() {
            return 'event-' + this.event.name + '-details';
        }
    }
});

/***/ }),
/* 105 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);

//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
    props: {
        args: Object
    },

    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])({
        game: 'game',
        getPlayer: 'getPlayer',
        localPlayer: 'localPlayer'
    }), {
        president: function president() {
            return this.getPlayer(this.args.president);
        },
        target: function target() {
            return this.getPlayer(this.args.target);
        }
    })
});

/***/ }),
/* 106 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);

//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
    props: {
        args: Object
    },

    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])({
        game: 'game',
        getPlayer: 'getPlayer',
        localPlayer: 'localPlayer'
    }), {
        president: function president() {
            return this.getPlayer(this.args.president);
        },
        target: function target() {
            return this.getPlayer(this.args.target);
        }
    })
});

/***/ }),
/* 107 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ui_government__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ui_government___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__ui_government__);

//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
    components: {
        Government: __WEBPACK_IMPORTED_MODULE_2__ui_government___default.a
    },

    props: {
        args: Object
    },

    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])({
        game: 'game',
        getPlayer: 'getPlayer',
        localPlayer: 'localPlayer'
    }), {
        president: function president() {
            return this.getPlayer(this.args.president);
        },
        target: function target() {
            return this.getPlayer(this.args.target);
        }
    })
});

/***/ }),
/* 108 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);

//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
    props: {
        args: Object
    },

    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])({
        game: 'game',
        getPlayer: 'getPlayer',
        localPlayer: 'localPlayer'
    }), {
        president: function president() {
            return this.getPlayer(this.args.president);
        },
        target: function target() {
            return this.getPlayer(this.args.target);
        }
    })
});

/***/ }),
/* 109 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);

//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
    props: {
        args: Object
    },

    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])({
        game: 'game',
        getPlayer: 'getPlayer',
        localPlayer: 'localPlayer'
    }), {
        president: function president() {
            return this.getPlayer(this.args.president);
        },
        chancellor: function chancellor() {
            return this.getPlayer(this.args.chancellor);
        }
    })
});

/***/ }),
/* 110 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ui_government__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ui_government___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__ui_government__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ui_cards_policy__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ui_cards_policy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__ui_cards_policy__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
    components: {
        Government: __WEBPACK_IMPORTED_MODULE_2__ui_government___default.a,
        PolicyCard: __WEBPACK_IMPORTED_MODULE_3__ui_cards_policy___default.a
    },

    props: {
        args: Object
    },

    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])({
        game: 'game',
        getPlayer: 'getPlayer',
        localPlayer: 'localPlayer'
    }), {
        policy: function policy() {
            return this.args.policy.toLowerCase();
        }
    })
});

/***/ }),
/* 111 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);

//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
    props: {
        args: Object
    },

    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])({
        game: 'game',
        getPlayer: 'getPlayer',
        localPlayer: 'localPlayer'
    }), {
        policy: function policy() {
            return this.args.policy.toLowerCase();
        }
    })
});

/***/ }),
/* 112 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);

//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
    props: {
        args: Object
    },

    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])({
        game: 'game',
        getPlayer: 'getPlayer',
        localPlayer: 'localPlayer'
    }), {
        president: function president() {
            return this.getPlayer(this.args.president);
        }
    })
});

/***/ }),
/* 113 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ui_role_assignment__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ui_role_assignment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__ui_role_assignment__);
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
    components: {
        RoleAssignment: __WEBPACK_IMPORTED_MODULE_0__ui_role_assignment___default.a
    }
});

/***/ }),
/* 114 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ui_government__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ui_government___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__ui_government__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
    components: {
        Government: __WEBPACK_IMPORTED_MODULE_2__ui_government___default.a
    },

    props: {
        args: Object
    },

    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])({
        game: 'game',
        getPlayer: 'getPlayer',
        localPlayer: 'localPlayer'
    }), {
        president: function president() {
            return this.getPlayer(this.args.president);
        },
        target: function target() {
            return this.getPlayer(this.args.target);
        }
    })
});

/***/ }),
/* 115 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);

//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
    props: {
        args: Object
    },

    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])({
        game: 'game',
        getPlayer: 'getPlayer',
        localPlayer: 'localPlayer'
    }), {
        president: function president() {
            return this.getPlayer(this.args.president);
        },
        target: function target() {
            return this.getPlayer(this.args.target);
        }
    })
});

/***/ }),
/* 116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);

//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
    props: {
        args: Object
    },

    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])({
        game: 'game',
        getPlayer: 'getPlayer',
        localPlayer: 'localPlayer'
    }))
});

/***/ }),
/* 117 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ui_government__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ui_government___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__ui_government__);

//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
    components: {
        Government: __WEBPACK_IMPORTED_MODULE_2__ui_government___default.a
    },

    props: {
        args: Object
    },

    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])({
        game: 'game',
        getPlayer: 'getPlayer',
        localPlayer: 'localPlayer'
    }))
});

/***/ }),
/* 118 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);

//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
    props: {
        args: Object
    },

    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])({
        game: 'game',
        getPlayer: 'getPlayer',
        localPlayer: 'localPlayer'
    }))
});

/***/ }),
/* 119 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ui_players_list__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ui_players_list___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__ui_players_list__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ui_government__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ui_government___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__ui_government__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
    components: {
        PlayerList: __WEBPACK_IMPORTED_MODULE_2__ui_players_list___default.a,
        Government: __WEBPACK_IMPORTED_MODULE_3__ui_government___default.a
    },

    props: {
        args: Object
    },

    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])({
        game: 'game',
        getPlayer: 'getPlayer',
        allPlayers: 'allPlayers',
        localPlayer: 'localPlayer'
    }), {
        president: function president() {
            return this.getPlayer(this.args.president);
        },
        chancellor: function chancellor() {
            return this.getPlayer(this.args.chancellor);
        }
    }),

    methods: {
        getVote: function getVote(player) {
            return this.args.votes.ja.includes(player.id);
        }
    }
});

/***/ }),
/* 120 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
    props: {
        args: Object
    },

    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])({
        game: 'game',
        getPlayer: 'getPlayer',
        localPlayer: 'localPlayer'
    }), {
        president: function president() {
            return this.getPlayer(this.args.president);
        },
        chancellor: function chancellor() {
            return this.getPlayer(this.args.chancellor);
        }
    })
});

/***/ }),
/* 121 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);


//
//
//
//

var regex = /([\w-]+)\/preview.vue$/;
var context = __webpack_require__(365);
var components = {};

var _iteratorNormalCompletion = true;
var _didIteratorError = false;
var _iteratorError = undefined;

try {
    for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(context.keys()), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var key = _step.value;

        var match = regex.exec(key);
        var options = context(key);

        components['event-' + match[1] + '-preview'] = options;
    }
} catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
} finally {
    try {
        if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
        }
    } finally {
        if (_didIteratorError) {
            throw _iteratorError;
        }
    }
}

/* harmony default export */ __webpack_exports__["default"] = ({
    components: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, components),

    props: {
        event: Object
    },

    computed: {
        component: function component() {
            return 'event-' + this.event.name + '-preview';
        }
    }
});

/***/ }),
/* 122 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])({
        game: 'game'
    }), {
        result: function result() {
            return this.game.victory;
        },
        team: function team() {
            switch (this.game.victory) {
                case 'FASCIST_HITLER':
                case 'FASCIST_POLICY':
                    return 'fascist';
                case 'LIBERAL_HITLER':
                case 'LIBERAL_POLICY':
                    return 'liberal';
            }
        }
    }),

    methods: {
        submit: function submit() {
            this.$store.dispatch('reset');
        }
    }
});

/***/ }),
/* 123 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ui_players_selector__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ui_players_selector___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__ui_players_selector__);

//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
    components: {
        PlayerSelector: __WEBPACK_IMPORTED_MODULE_2__ui_players_selector___default.a
    },

    data: function data() {
        return {
            target: null
        };
    },


    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])({
        game: 'game',
        localPlayer: 'localPlayer'
    }), {
        action: function action() {
            return this.game.executiveAction;
        }
    }),

    methods: {
        submit: function submit() {
            this.$send('SET_ACTION_TARGET', { target: this.target.id });
        }
    }
});

/***/ }),
/* 124 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ui_players_selector__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ui_players_selector___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__ui_players_selector__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
    components: {
        PlayerSelector: __WEBPACK_IMPORTED_MODULE_2__ui_players_selector___default.a
    },

    data: function data() {
        return {
            target: null
        };
    },


    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])({
        game: 'game',
        getPlayer: 'getPlayer',
        localPlayer: 'localPlayer'
    }), {
        action: function action() {
            return this.game.executiveAction;
        },
        learned_player: function learned_player() {
            return this.getPlayer(this.action.target);
        },
        learned_result: function learned_result() {
            if (this.action.learned == null) return null;

            if (this.action.learned.membership == 'LIBERAL') return 'liberal';

            return 'fascist';
        }
    }),

    methods: {
        filter: function filter(p) {
            return p != this.localPlayer;
        },
        submit: function submit() {
            this.$send('SET_ACTION_TARGET', { target: this.target.id });
        },
        finish: function finish() {
            this.$send('COMPLETE_ACTION');
        }
    }
});

/***/ }),
/* 125 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ui_cards_policy__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ui_cards_policy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__ui_cards_policy__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
    components: {
        PolicyCard: __WEBPACK_IMPORTED_MODULE_2__ui_cards_policy___default.a
    },

    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])({
        game: 'game',
        localPlayer: 'localPlayer'
    }), {
        action: function action() {
            return this.game.executiveAction;
        }
    }),

    methods: {
        complete: function complete() {
            this.$send('COMPLETE_ACTION');
        }
    }
});

/***/ }),
/* 126 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ui_players_selector__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ui_players_selector___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__ui_players_selector__);

//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
    components: {
        PlayerSelector: __WEBPACK_IMPORTED_MODULE_2__ui_players_selector___default.a
    },

    data: function data() {
        return {
            target: null
        };
    },


    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])({
        game: 'game',
        localPlayer: 'localPlayer'
    }), {
        action: function action() {
            return this.game.executiveAction;
        }
    }),

    methods: {
        filter: function filter(p) {
            return p != this.localPlayer;
        },
        submit: function submit() {
            this.$send('SET_ACTION_TARGET', { target: this.target.id });
        }
    }
});

/***/ }),
/* 127 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions_bullet__ = __webpack_require__(289);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions_bullet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__actions_bullet__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions_inspect__ = __webpack_require__(290);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions_inspect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__actions_inspect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actions_preview_deck__ = __webpack_require__(291);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actions_preview_deck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__actions_preview_deck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__actions_special_election__ = __webpack_require__(292);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__actions_special_election___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__actions_special_election__);

//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["default"] = ({
    components: {
        ActionBullet: __WEBPACK_IMPORTED_MODULE_2__actions_bullet___default.a,
        ActionInspect: __WEBPACK_IMPORTED_MODULE_3__actions_inspect___default.a,
        ActionPreviewDeck: __WEBPACK_IMPORTED_MODULE_4__actions_preview_deck___default.a,
        ActionSpecialElection: __WEBPACK_IMPORTED_MODULE_5__actions_special_election___default.a
    },

    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])({
        game: 'game',
        localPlayer: 'localPlayer'
    }), {
        isPresident: function isPresident() {
            return this.action.president == this.localPlayer.id;
        },
        action: function action() {
            return this.game.executiveAction;
        },
        type: function type() {
            return this.action.type.toLowerCase().replace('_', '-');
        }
    })
});

/***/ }),
/* 128 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__policy_selector__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__policy_selector___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__policy_selector__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
    components: {
        PolicySelector: __WEBPACK_IMPORTED_MODULE_2__policy_selector___default.a
    },

    data: function data() {
        return {
            discarding: null
        };
    },


    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])({
        game: 'game',
        localPlayer: 'localPlayer'
    }), {
        session: function session() {
            return this.game.legislature;
        },
        isReady: function isReady() {
            return this.discarding != null;
        },
        showVeto: function showVeto() {
            return this.game.boardState.fascists == 5;
        },
        canVeto: function canVeto() {
            return this.showVeto && !this.session.vetoRequested;
        }
    }),

    methods: {
        veto: function veto() {
            this.$send('LEGISLATURE_VETO');
        },
        submit: function submit() {
            if (this.session.chancellor == this.localPlayer.id) {
                this.$send('LEGISLATURE_DISCARD', { card: this.discarding });
            }
        }
    }
});

/***/ }),
/* 129 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ui_government__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ui_government___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__ui_government__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__president_policies__ = __webpack_require__(296);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__president_policies___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__president_policies__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__chancellor_policies__ = __webpack_require__(294);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__chancellor_policies___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__chancellor_policies__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["default"] = ({
    components: {
        Government: __WEBPACK_IMPORTED_MODULE_2__ui_government___default.a,
        PresidentPolicies: __WEBPACK_IMPORTED_MODULE_3__president_policies___default.a,
        ChancellorPolicies: __WEBPACK_IMPORTED_MODULE_4__chancellor_policies___default.a
    },

    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])({
        game: 'game',
        getPlayer: 'getPlayer',
        localPlayer: 'localPlayer'
    }), {
        president: function president() {
            return this.getPlayer(this.session.president);
        },
        chancellor: function chancellor() {
            return this.getPlayer(this.session.chancellor);
        },
        session: function session() {
            return this.game.legislature;
        },
        state: function state() {
            if (this.president.isLocalPlayer) {
                if (this.session.vetoRequested && this.session.vetoAccepted === null) return 'pres_veto';
                if (this.session.chancellorCards == null) return 'pres_cards';
                return 'pres_waiting';
            }

            if (this.chancellor.isLocalPlayer) {
                if (this.session.vetoRequested && this.session.vetoAccepted === null) return 'chan_veto';
                if (this.session.chancellorCards != null) return 'chan_cards';
                return 'chan_waiting';
            }

            return 'bystander';
        }
    }),

    methods: {
        veto: function veto(accept) {
            this.$send('LEGISLATURE_VETO', { response: accept });
        }
    }
});

/***/ }),
/* 130 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ui_cards_policy__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ui_cards_policy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__ui_cards_policy__);

//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
    components: {
        PolicyCard: __WEBPACK_IMPORTED_MODULE_1__ui_cards_policy___default.a
    },

    props: {
        value: String,
        cards: Array
    },

    data: function data() {
        return {
            flipped: false,
            selected: []
        };
    },


    methods: {
        onClick: function onClick(i) {
            if (!this.flipped) {
                this.flipped = true;
                this.$emit('input', null);
                return;
            } else {
                var index = this.selected.indexOf(i);
                if (index < 0) this.selected.push(i);else this.selected.splice(index, 1);
            }

            var is = this.cards.map(function (p, i) {
                return i;
            });
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.selected), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var pass = _step.value;

                    is.splice(is.indexOf(pass), 1);
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }

            if (is.length != 1) {
                this.$emit('input', null);
            } else {
                this.$emit('input', this.cards[is[0]]);
            }
        }
    }
});

/***/ }),
/* 131 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__policy_selector__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__policy_selector___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__policy_selector__);

//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
    components: {
        PolicySelector: __WEBPACK_IMPORTED_MODULE_2__policy_selector___default.a
    },

    data: function data() {
        return {
            discarding: null
        };
    },


    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])({
        game: 'game',
        localPlayer: 'localPlayer'
    }), {
        session: function session() {
            return this.game.legislature;
        },
        isReady: function isReady() {
            return this.discarding != null;
        }
    }),

    methods: {
        submit: function submit() {
            if (this.session.president == this.localPlayer.id) {
                this.$send('LEGISLATURE_DISCARD', { card: this.discarding });
            }
        }
    }
});

/***/ }),
/* 132 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__socket__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ui_players_list__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ui_players_list___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__ui_players_list__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'LobbyView',

    components: {
        PlayerList: __WEBPACK_IMPORTED_MODULE_4__ui_players_list___default.a
    },

    computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])({
        game: 'game',
        allPlayers: 'allPlayers',
        localPlayer: 'localPlayer'
    }), {
        players: function players() {
            return [this.localPlayer].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.others));
        },
        others: function others() {
            var _this = this;

            return this.allPlayers.filter(function (p) {
                return p != _this.localPlayer;
            });
        }
    }),

    methods: {
        ready: function ready(isReady) {
            this.$send('SET_READY', { isReady: isReady });
        },
        cancel: function cancel() {
            __WEBPACK_IMPORTED_MODULE_3__socket__["e" /* reset */]();
        }
    }
});

/***/ }),
/* 133 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ui_players_selector__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ui_players_selector___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__ui_players_selector__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ui_government__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ui_government___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__ui_government__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
    components: {
        PlayerSelector: __WEBPACK_IMPORTED_MODULE_2__ui_players_selector___default.a,
        Government: __WEBPACK_IMPORTED_MODULE_3__ui_government___default.a
    },

    data: function data() {
        return {
            selected: null
        };
    },


    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])({
        game: 'game',
        getPlayer: 'getPlayer',
        localPlayer: 'localPlayer'
    }), {
        president: function president() {
            return this.getPlayer(this.game.nomination.president);
        },
        isPresident: function isPresident() {
            return this.president == this.localPlayer;
        }
    }),

    methods: {
        isValid: function isValid(p) {
            return !p.isTermLimited && !p.isLocalPlayer;
        },
        nominate: function nominate() {
            this.$send('NOMINATE', { playerId: this.selected.id });
        }
    }
});

/***/ }),
/* 134 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ui_cards_voting__ = __webpack_require__(268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ui_cards_voting___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__ui_cards_voting__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ui_players_list__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ui_players_list___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__ui_players_list__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ui_government__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ui_government___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__ui_government__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
    components: {
        VotingCard: __WEBPACK_IMPORTED_MODULE_2__ui_cards_voting___default.a,
        PlayerList: __WEBPACK_IMPORTED_MODULE_3__ui_players_list___default.a,
        Government: __WEBPACK_IMPORTED_MODULE_4__ui_government___default.a
    },

    data: function data() {
        return {
            vote: null,
            selected: null
        };
    },


    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])({
        game: 'game',
        getPlayer: 'getPlayer',
        allPlayers: 'allPlayers',
        localPlayer: 'localPlayer'
    }), {
        president: function president() {
            return this.getPlayer(this.game.nomination.president);
        },
        chancellor: function chancellor() {
            return this.getPlayer(this.game.nomination.chancellor);
        }
    }),

    methods: {
        filter: function filter(player) {
            return !player.hasVoted;
        },
        submit: function submit() {
            this.$send('SUBMIT_VOTE', { vote: this.vote });
        }
    }
});

/***/ }),
/* 135 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ui_role_assignment__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ui_role_assignment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__ui_role_assignment__);
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
    components: {
        RoleAssignment: __WEBPACK_IMPORTED_MODULE_0__ui_role_assignment___default.a
    }
});

/***/ }),
/* 136 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);

//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])({
        game: 'game'
    }))
});

/***/ }),
/* 137 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__login_page__ = __webpack_require__(303);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__login_page___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__login_page__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__dead_player__ = __webpack_require__(301);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__dead_player___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__dead_player__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__result_alert__ = __webpack_require__(304);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__result_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__result_alert__);



//
//
//
//
//
//
//
//
//
//
//
//







var regex = /([\w-]+)\/index.vue$/;
var context = __webpack_require__(366);
var gameStates = {};

var _iteratorNormalCompletion = true;
var _didIteratorError = false;
var _iteratorError = undefined;

try {
    for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(context.keys()), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var key = _step.value;

        var match = regex.exec(key);
        var name = match[1].toLowerCase();
        var options = context(key);

        gameStates['game-' + name + '-state'] = options;
    }
} catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
} finally {
    try {
        if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
        }
    } finally {
        if (_didIteratorError) {
            throw _iteratorError;
        }
    }
}

/* harmony default export */ __webpack_exports__["default"] = ({
    components: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({
        DeadView: __WEBPACK_IMPORTED_MODULE_5__dead_player___default.a,
        LoginView: __WEBPACK_IMPORTED_MODULE_4__login_page___default.a,
        ResultView: __WEBPACK_IMPORTED_MODULE_6__result_alert___default.a

    }, gameStates),

    computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapGetters */])({
        game: 'game',
        results: 'results',
        localPlayer: 'localPlayer'
    }), {
        raw: function raw() {
            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(this.game, null, 4);
        },
        page: function page() {
            return 'game-' + this.game.state.toLowerCase() + '-state';
        },
        isDead: function isDead() {
            return this.game.state != 'COMPLETED' && this.localPlayer.isAlive === false;
        },
        result: function result() {
            return this.results[0];
        }
    })
});

/***/ }),
/* 138 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__socket__ = __webpack_require__(12);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            name: '',
            gameCode: ''
        };
    },


    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])({
        connection: 'connection'
    })),

    created: function created() {
        try {
            this.name = localStorage.getItem('secret-hitler/name') || '';
        } catch (e) {}
    },


    methods: {
        onKeyDown: function onKeyDown(e) {
            if (e.keyCode == 13) this.start();
        },
        create: function create() {
            try {
                localStorage.setItem('secret-hitler/name', this.name);
            } catch (e) {}

            __WEBPACK_IMPORTED_MODULE_2__socket__["c" /* create */](this.name);
        },
        join: function join() {
            try {
                localStorage.setItem('secret-hitler/name', this.name);
            } catch (e) {}

            __WEBPACK_IMPORTED_MODULE_2__socket__["d" /* join */](this.gameCode, this.name);
        }
    }
});

/***/ }),
/* 139 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__player_ui_events_details__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__player_ui_events_details___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__player_ui_events_details__);
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
    components: {
        EventDetails: __WEBPACK_IMPORTED_MODULE_0__player_ui_events_details___default.a
    },

    props: {
        result: Object
    },

    methods: {
        accept: function accept() {
            this.$store.commit('POP_RESULT');
        }
    }
});

/***/ }),
/* 140 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__player_ui_events_details__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__player_ui_events_details___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__player_ui_events_details__);

//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
    components: {
        EventDetails: __WEBPACK_IMPORTED_MODULE_2__player_ui_events_details___default.a
    },

    props: {
        index: String
    },

    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])({
        game: 'game'
    }), {
        event: function event() {
            return this.game.log[this.index];
        }
    })
});

/***/ }),
/* 141 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__player_ui_events_preview__ = __webpack_require__(287);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__player_ui_events_preview___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__player_ui_events_preview__);

//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
    components: {
        EventPreview: __WEBPACK_IMPORTED_MODULE_2__player_ui_events_preview___default.a
    },

    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])({
        game: 'game'
    }), {
        log: function log() {
            return this.game.log.slice().reverse();
        }
    }),

    methods: {
        onDetails: function onDetails(e) {
            var i = this.game.log.indexOf(e);
            this.$router.push('/log/' + i);
        }
    }
});

/***/ }),
/* 142 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__socket__ = __webpack_require__(12);
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
    methods: {
        abandon: function abandon() {
            __WEBPACK_IMPORTED_MODULE_0__socket__["e" /* reset */]();
            this.$router.push('/');
        }
    }
});

/***/ }),
/* 143 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "state", function() { return state; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getters", function() { return getters; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "mutations", function() { return mutations; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "actions", function() { return actions; });
var state = {
    error: null,
    connection: null
};

var getters = {
    error: function error(state) {
        return state.error;
    },
    connection: function connection(state) {
        return state.connection;
    }
};

var mutations = {
    RESET_CONNECTION: function RESET_CONNECTION(state) {
        state.connection = null;
    },
    SET_CONNECTION: function SET_CONNECTION(state, value) {
        state.connection = value;
    },
    SET_ERROR: function SET_ERROR(state, value) {
        state.error = value;
    }
};

var actions = {};

/***/ }),
/* 144 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "state", function() { return state; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getters", function() { return getters; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "mutations", function() { return mutations; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "actions", function() { return actions; });
var state = {
    game: null,
    results: []
};

var getters = {
    game: function game(state) {
        return state.game;
    },
    results: function results(state) {
        return state.results;
    },
    allPlayers: function allPlayers(state) {
        if (!state.game) return null;

        if (state.game.state == 'LOBBY') return state.game.players.sort(function (a, b) {
            return a.name.localeCompare(b.name);
        });

        return state.game.players.sort(function (a, b) {
            return a.index - b.index;
        });
    },


    getPlayer: function getPlayer(state, getters) {
        return function (id) {
            if (!state.game) return null;

            return getters.allPlayers.find(function (p) {
                return p.id == id;
            });
        };
    },

    localPlayer: function localPlayer(state, getters) {
        if (!state.game) return null;

        return getters.allPlayers.find(function (p) {
            return p.isLocalPlayer;
        });
    }
};

var mutations = {
    RESET_GAME: function RESET_GAME(state) {
        state.game = null;
        state.results = [];
    },
    SET_GAME: function SET_GAME(state, value) {
        state.game = value;
    },
    POST_RESULT: function POST_RESULT(state, value) {
        state.results.push(value);
    },
    POP_RESULT: function POP_RESULT(state) {
        state.results.shift();
    }
};

var actions = {};

/***/ }),
/* 145 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__simple_page__ = __webpack_require__(270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__simple_page___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__simple_page__);




__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('uikit:simple-page', __WEBPACK_IMPORTED_MODULE_1__simple_page___default.a);

/***/ }),
/* 146 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__touch_class__ = __webpack_require__(147);




__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].directive('touch-class', __WEBPACK_IMPORTED_MODULE_1__touch_class__);

/***/ }),
/* 147 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["inserted"] = inserted;
var ignoreNextClick = false;

function inserted(el, binding, vnode) {
    var isPressed = false;
    var touchStart = null;

    function cancel() {
        setPressed(false);
        touchStart = null;
    }

    function setPressed(value) {
        isPressed = value;

        var key = binding.expression || 'touch-active';

        if (!vnode.data.class) vnode.data.class = [];

        if (vnode.context.$styleMapping) key = vnode.context.$styleMapping(key);

        el.classList.toggle(key, value);
    }

    el.addEventListener('touchstart', function (e) {
        touchStart = {
            x: e.changedTouches[0].clientX,
            y: e.changedTouches[0].clientY
        };
        setPressed(true);
    }, { passive: true });

    el.addEventListener('touchend', function (e) {
        if (!touchStart) return;

        cancel();
    }, { passive: true });

    el.addEventListener('touchcancel', cancel, { passive: true });
}

/***/ }),
/* 148 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vuetify_styl__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vuetify_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__vuetify_styl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__fonts_less__ = __webpack_require__(191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__fonts_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__fonts_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mdi_css_materialdesignicons_min_css__ = __webpack_require__(190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mdi_css_materialdesignicons_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_mdi_css_materialdesignicons_min_css__);





/***/ }),
/* 149 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ui_App_vue__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ui_App_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__ui_App_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__debug__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__socket__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__init__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__uikit__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets__ = __webpack_require__(84);













__WEBPACK_IMPORTED_MODULE_4__debug__["a" /* init */](__WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_5__socket__["a" /* init */](__WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$send = function (name, args) {
    __WEBPACK_IMPORTED_MODULE_5__socket__["b" /* send */](name, args);
};

new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
    el: '#app',
    store: __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */],
    router: __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */],
    render: function render(h) {
        return h(__WEBPACK_IMPORTED_MODULE_1__ui_App_vue___default.a);
    }
});

__WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */].push('/');

/***/ }),
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 190 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 191 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 192 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"player-name":"_11XsCr5ofkhvcCmPh4N47o_0","content":"hqNhZVS--rptga9zquaxU_0","scores":"_23ALZUWwKZ8xIoMwZN2JzY_0","election-tracker":"_12hiRMg7-3qtLBOVNOq6Da_0","score":"_8AGE0JaQtA5DDUL7MLtZu_0","raw":"_17XNLEQmrio2ZTBaKFfpHy_0"};

/***/ }),
/* 193 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"player-name":"LkMwZslDydtb-iQzfuVlq_0","legistlature-view":"_2QRRlPLy7Mfckk76vgKl5h_0","header":"d5b_bTXpcvjfpbIGzV-Xr_0","cards":"te_KSl1Pra4PckbBodOjZ_0","active":"_1PWcnfxSxwMl2JvMTPP75_0","bottom":"PXXLixRgMftwQOi8JB9_q_0"};

/***/ }),
/* 194 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"player-name":"_2atTe6ciRKI5vt398yHhMv_0","info":"_2yV3slgrIhMM9EYQicCFpX_0","policy":"_1RyPx9FPqJza-tzaLSVe4Q_0","liberal":"_1Bfza4wL3S5vMB4JKtJdZD_0","fascist":"MHp0nalb2o0cwq8fs0-Av_0"};

/***/ }),
/* 195 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"player-name":"_2msLL2MTS1-Ij_3EjIDWN-_0","large-player":"_1U10boKSsg9StWHMW8mWCB_0","player":"_1YUO_hV5QcB8MDtrSYyVdQ_0"};

/***/ }),
/* 196 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"player-name":"_3XQHs7CtsWl8pQoJPp5917_0"};

/***/ }),
/* 197 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"player-name":"_1IdTikkuWBMk7LkMcyl0vJ_0","icon":"_2yAAeAJGWWQ8A1KmlEJsXc_0"};

/***/ }),
/* 198 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"player-name":"_2ekfSuun8TZmpzo5oNibKq_0","preview-deck":"civU1_dgFqvUKLE7XF_gS_0","card":"_1BjozjUolwY4WIX686Gs0J_0","bottom":"_2W4oH-a68lRUy3606iCD-Z_0"};

/***/ }),
/* 199 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"player-name":"_351FINURQ_n9wz90mWGO_N_0"};

/***/ }),
/* 200 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"player-name":"_1niaf634PEZ55ByEwe_VYt_0","card-box":"wBfA_5rTIPfOZhnY0Mrp6_0","active":"Nb1b5lH4415rlAn7a46HB_0"};

/***/ }),
/* 201 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"player-name":"GZ9onxQOZpmWmSkuybxd0_0","policy":"_1zq1LEZazbwlRnz_Bfn-ke_0","liberal":"lvOM43nORnXbZj-cJ6JV4_0","fascist":"_1GjkgF_vgCyepLAzwknodL_0"};

/***/ }),
/* 202 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"player-name":"_1x1nENCI0I7UZOY0sb9MMm_0","preview-deck":"_2EM8-r7DVC9ns3gXzet0Ib_0","card":"mCuaRiLqMlHODWPz93XGc_0","bottom":"_2C2qCl0AbKDn8ak_AT7dMV_0"};

/***/ }),
/* 203 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"player-name":"-UUvTO1WqgfjnauTyGSsx_0"};

/***/ }),
/* 204 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"player-name":"_3rjTRyFXKYvJJHvjzH4tgw_0"};

/***/ }),
/* 205 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"player-name":"_3Lc4uzgqoERRK9-DSJomW5_0","card-box":"_1DY5FGZhhsJ1OqgIQLWpHG_0","active":"_35SeNjnKj0gFvL2KPjfp3E_0"};

/***/ }),
/* 206 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"player-name":"_2oCM9UnO0nQPlCPftLH7iR_0"};

/***/ }),
/* 207 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"player-name":"JS-peo85L_CK-Uu82m7AV_0"};

/***/ }),
/* 208 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"player-name":"_3JRejo1o2oj9BgLvcYEf67_0","nominating-view":"_2Va_Lf7oqVUZFawOVhj4QA_0","is-president":"_17HxWmKumo5AJRTs-OMtD_0","list":"_1PFkV-XkpBPSDf2AkslYYU_0","bottom":"_1IQ4jbO-38lDG8C1qNsxk_0"};

/***/ }),
/* 209 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"player-name":"_1ZfC6GwM9CWSFzLyCK-fhQ_0"};

/***/ }),
/* 210 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"player-name":"_3EdHVAmtG-ArRoPsMODKG0_0","header":"PUiofADk28YgUqknj448Q_0","card-box":"_2iTJYEtT6axZF2h5BzsWh5_0","active":"Yaty6nlaFNr9W_EDuc6xz_0"};

/***/ }),
/* 211 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"player-name":"if1A4QURNUWlSHzlVZ_es_0","preview-deck":"_3Ed_v7wTrSU_l5NhA9L9b-_0","card":"_1g4e-qW_QtMc03Hi42wPmi_0"};

/***/ }),
/* 212 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"player-name":"Zf46VGLotjUZqRBhTry3-_0","card-box":"_2SokrAz2p4IbZxq-LgBv1I_0","active":"_3nXYRFF00wBHBwJ7Cl2dIG_0"};

/***/ }),
/* 213 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"player-name":"_2PQck6TNAcZgxASTp-YTVy_0"};

/***/ }),
/* 214 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"player-name":"_3dZ0JuRWBaMd4eybMBraJJ_0","icon":"_3f30-3M_htgqSuG3PVMIIt_0"};

/***/ }),
/* 215 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"player-name":"_3pvzxjg-SH0X1SRS1mqbel_0"};

/***/ }),
/* 216 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"player-name":"b6eyd3Tbml6VcrgKPpB8c_0","arrow":"_23BUVdfazVUTXiCG4Gg7L1_0"};

/***/ }),
/* 217 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"result-view":"_1Q2y2SFK4wQGA15XNoAs0i_0"};

/***/ }),
/* 218 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"player-name":"_3WccBXH7BAdoEtELianT7S_0","header":"_3r9rDzZXznyzY7aimF6Lgx_0"};

/***/ }),
/* 219 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"player-name":"_16t9EgNt5SK5yse9qNCBft_0","box-container":"TE7OMeZEVzI3XSqmbJMY9_0","box":"X3aZ7g89NI4p77F7fOSeV_0"};

/***/ }),
/* 220 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"player-name":"L46j7zawt496RimCRV9pg_0"};

/***/ }),
/* 221 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"player-name":"_3tY7uOhYDHHU1FpCdq6SIR_0"};

/***/ }),
/* 222 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"player-name":"_3CqmSfn-ek6jGOqnV215rQ_0"};

/***/ }),
/* 223 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"player-name":"_3_8dLegWUedGAMESjBB9eo_0"};

/***/ }),
/* 224 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"player-name":"_1n_NONHMANXtO5LuwK2iYx_0","preview-deck":"_2r_oVuecPyNvJxweueug6g_0","card":"_2sB7z9VckSmxTePI4KFEm_0","bottom":"_1CJwmKccKfDB5Ta7JkYl7q_0"};

/***/ }),
/* 225 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"player-name":"_1lGtCkRi0t12aOXK1NJ8VA_0","info":"_1pYhnZ5xNlpuYUlUoxXqXL_0","card":"_3QD7rwmPqMoACXUijgr9dT_0"};

/***/ }),
/* 226 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"player-name":"_3rFkxWuKMNRDKKvpKP0qVd_0"};

/***/ }),
/* 227 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"player-name":"_1mGa5zmhpURYclbRqNFpFf_0"};

/***/ }),
/* 228 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"player-name":"_2fD7KlcKFXUFY9hjE0B83p_0","art":"_1YLMb5Of6DtGJWoUCu0giz_0","icon":"_3qCGSFtJDvI1LChmAbUphO_0"};

/***/ }),
/* 229 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"player-name":"_2OOIOcI8XLhLL2YZgj9RpA_0"};

/***/ }),
/* 230 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"player-name":"_2ZBjvClsdDrboWvwrw98vv_0","card":"ct7KNX1ZdM2Ag73GeK05R_0","info":"lmAPuR9D2W3zY7XJmHmUN_0"};

/***/ }),
/* 231 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"player-name":"_1KR1DVZQAPqg5LPFQkZC4n_0","group":"_3NXAtiktimPmshp8g0KdsM_0","divider":"_1PE0MHB30kSkOngdNveQsE_0"};

/***/ }),
/* 232 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"card":"_2Thp_pcWVJZ02IutRgpdoF_0","rotation":"_3FAM-zm4C4NbppNOeFjiuf_0","horizontal":"_2c9Mu7Bb-brbr60YbBK2FB_0","flipper":"_3S4hb-pxK58wq4rcT4vIs1_0","flipped":"_1AMC82bLaP4NnC_oLKHFc__0","border":"_2oQCMXAj_e8y4BaCte0iDc_0","front":"RUhJZ-5NBVHSO027S9Whn_0","back":"_1sJ9KF-ZN3vA3eCjOkU1I0_0"};

/***/ }),
/* 233 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"player-name":"_3lAvWeL7YBOX0CtbzNx4Jl_0","dialog-contents":"_1oJG4J6vE84SjdXL9BOYmv_0","player":"_1ru7NljCG1ocr4mLUjsbso_0","active":"tWf9h1T32eIRhtty4DWRK_0"};

/***/ }),
/* 234 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"player-name":"_1ptcvvsZIu9K9jVbl4Gjuy_0"};

/***/ }),
/* 235 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"player-name":"_2wkm1-HB6uWw7YUq6YsBR0_0"};

/***/ }),
/* 236 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"player-name":"_3-Le0C81KIgAOZN0Pisojq_0"};

/***/ }),
/* 237 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"player-name":"_1opo4TCkUxC7JRZ43bhQ8e_0"};

/***/ }),
/* 238 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"player-name":"i1ThpjhL4LvHPU3WI6PC4_0"};

/***/ }),
/* 239 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"player-name":"_275QhRIXp_Iu5mifYEmkRR_0","ballot":"_1nK52lIeGkLkjfUiQc0i4O_0","president":"z7qyAN6bQhgKZ-xqoOeuD_0","chancellor":"_2MwFbWxe8_tm9mx6le5t5g_0","name":"_3T0qTzUOkJwoJEn6aU4ri__0"};

/***/ }),
/* 240 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"login-page":"_1yiKFrJuOIs6p23xGdSjTq_0","logo":"_2aheEpw3u4Mf1c8r0-ABvi_0","watch":"_2GDEyqiKrm5kHMl8tzxVDW_0","raw":"_2bSNu7EUiSTAOtiyDQMZEJ_0"};

/***/ }),
/* 241 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 242 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/fascist_l.56d8f0f.png";

/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/fascist_m.8ab3172.png";

/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/fascist_s.01d2d3e.png";

/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/liberal.bdd6b33.png";

/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/logo.9c75e3f.svg";

/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/box.ec68d19.svg";

/***/ }),
/* 258 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/fascist-victory.b04aded.png";

/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/gun.6dd88d4.svg";

/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/liberal-victory.786f6ea.png";

/***/ }),
/* 262 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 263 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAa8AAACACAMAAACLOBZkAAAAz1BMVEVERET///9BQUE8PDw+Pj79/f3h4eFKSkpISEjq6upGRkb6+vpNTU3x8fHn5+fV1dVxcXFkZGR4eHhPT0/z8/P39/d9fX3e3t5XV1f19fWAgICKioqfn586OjqOjo5SUlLLy8vs7Oza2tqampqRkZGwsLDu7u5ubm5paWleXl7Hx8ezs7NhYWHX19e7u7vj4+Orq6umpqZUVFTIyMhbW1vS0tKioqJsbGxmZmaHh4eDg4PDw8O4uLh1dXWTk5OWlpbPz8/w8PDAwMC9vb3Nzc1N0gpzAAAWFElEQVR42uyY246iQBRFq0pLFK94QRRGGRWFBm2xFRAVbbv//5sGKG6DPkymXzCp9bZi2GfHrYkRQMorQfd6LeherwXd67Wge70WdK/Xgu71WtC9XguQleHC5i7bPpG60uXUyQESmubFsL1hZDXJNjpSLX7Ms43kMXgQHY7X6zAAw7cjx7l3iImex45zlCFhoHQNe7KObGl1DHteiax19Q9Yy8hmnmp0t6PI5KPqjM+YCN6MOef4AZ939iOvs7jlcTdVkwOziap1zGZktyO37yr1KPI0NjR+E0fqXYNz4879bUfjJrfIfksrTb0OI6t4qrayapGtJ5x22UYHsOz6ked63JnXDPcECSPloqVvytJc7R0v7tya29qKdH7cazAuAx/E6oG9MSiwcmcZmAJCQ8fgJJ4jENo8fMyNHlMCa3aINcI67xoxISxwmJIQ53dg9yqx7iCINKNIEftW98ogRArfI74UvsScA2vZxHayL3gtkANcK7BTg0RePgNTEDE36DwSSyDECyPHJKS6DawWRfa+fMGzuPMhMLlHTA0PfLGkZrcftDTLgSEQdu4vokgpXJL/FVpDCZdUSyTyIwhpC8SMGelMDnRq4YeDJZH8yLeBRQ6wC/xkr7oKIpAJ4QbFtve7SYnZGGI3Mdd/zE7Mb/opxMJuIK4wsTEHiL9RbNMWxHo5NmMA8Tyxjh/Jo9hECPtqbKzf672RRJ4gPoAksgLxVxKiNWHdKqWdyWeRhIz9yKRzde7PJcTGKP5cTBL5DfFH0kR4h3X9V2zcCA7myYELhM1xbFXRj3Sic4ix/Ll2KLLexu/MEgk/Efhejs1owYGZHFiNYHORGP9krwVIMXU2FbVtodT49SRji3U3Y2bbSYU5y0Jq07d7IzXtpoOUVVtKQ9jxWsyY184cqJqykVrvfuqBhL18BinqwcqEdG9iOQ0RD5lIZi6rqTWUNyG13X2T6WzI21RY+1vKRPK3YymNnHx3k9dQw/rgUGLT832XmnDXMwccOdv5cruW017Sw141kAGhrJX/tqygf7bHyJ8fQP/R+YcHft75fw4g7jO/lw4ohQUJ9/xeHqAUFtQz83stAKW4NKz8XiagFBY01fN7DQGlsCCtkt8LdgClqFRF+LBXiwGUYoKc5uNecDgFlEKitp7+37uk37AiwroQPt2rTr9gRYTxnu81or84ignrDp7sNTAApaBc8ONeIqAUFeb6sFeLBZSigoxafi8FUAoL2p3ze10Bpbg0LPr//CvRkPJ7SYBSWNBUye8lA0phQftDfi/8h50z70obCAL4zGSXnMgZhGq4LBhQJNIggqC0+v0/U5flMMe2fUDfK32P3x8o2dP3M2QymgnhzMmySN9/vRCcOU2oukz7wuAs7DShxrsy39uHM6eIf4kqX9w+/z3lFDGuUOmrW4AzJ8kiq/CVrcKZE2Xipn3N4MypYtTT+Xk4c7JQ7yLpK4AzJ8s5P/+fcc7P/1+k8/NPcOZkoUaQ9PUBZ04WCnNJX/z871EnTDF9/7WEMycKhe20L3yAw2EUFqfTL4Xkk8LaBtiwfc9Uc/yxiUDyx6mIVRez6WzixEeQliTdFh2hblEtZzxXxE+fH7FtH/WijA6M5vvK/HzOAqJD5tNfc7hh8FpisMV4yKy5tEDitDcHfuzWSXVeQgpnOZRNnYibUWaYkcxTwip9G9eYQSGym68XmRjDgU/bttm6bdj+ktiZXt+0DIoEKqgXXOAG96VC8V7G1MzsyD28hQz25tZEpa+yAW9T2Bsn4ChQnKfGVqNtgKRUQwkfpLf9vO1bodQKF5thT5/DqriGf0tMNe1ilHa4nU6/xgTZPCUTPuUrlvB1s+0sTCp4HmOMVnwC/SvGGU/2NWZMUekrEwJMnqFRgL1YlGUdmJuK7y/e+hzxIurLFr9W5aivsjhgK3wZHeTijBly3mcKX65ostGeUsRXVnaP+6rmkAtJT18mfr4+7woBtxFfYoVPWnFfXJwIptIXvxAtSl+kByjozutF//l2FrRRkAsp6ksOlwy7KLAD9leeJzIbIJndwT68rYZOgYGErGXcV9vTaB7xxR88DS4x7avhrvpq0EQ3TPvi3zyN5RHdPO182YGnGWbc120N0X5qaCAheIv7yvY8bQtdxX1lfY/5Sl/dnkdFpa/REhH7vrZpITYKOGIrz6K+TH+3KCxeEO2O9xee1+OVbSPBHrwi4iOtN8sYgPUt7uuSwHiI+SLQM2lfVh3tVxJfK2g/ksLXau4rxO892vnqMCjFffk28o8GbXZDQkPCV4FEyxpI+hJv8mpfBbK+KHzR6APRvNU2ERGT61b7QtgtffqS74xRo6HLDvksfp/t/5GY8pWBQ1hsrjekX82XueaTTwf60tv4vQSWA44pJkj76rOV1OttASm1r2oLeUe+LQbL3PKuol+lfFn58fJjxThzrC+ngzhwCIAKj2PTzN0taFMxaliluK8iCtyHeyYLZI3Z8c+bB3AATgv5Spf1tNOeOcxXHvkdsxavZFyj/YXUvsCYI8/90pc+R/tOA4BKF9e4H2lfFdxypC9LSMiUCKCQww3mjMncLO9rSV+SblFsOcBWng6o53B8vtd6XBfCcy5RkG3ZKDjIl/GOdoH09xxBiLzJVL6MCoGzlCXN1L4myAcEYDyiwDbLKFD54uXsmuHkCF80auP3PG0eVxVxVRZRbA6AGk38/oUlfLkvq2jk0lgtUrvWDsj3Hu/LcdG0APQcYreuaxq7nx/oq8r5mKBqZ4W0F3R7Kl9O/4bJUnwBU/pyfmAtT7JEHg+qmqaVblylr3LRW6MBHO5LHLLnHoj5kPcLYjlWfbTRftcAfMSxlvCVvfKMJ+x+YXRv23feP8nP15ELzdb1Z9VAmrgqXy7zJFZZ7cu6WYXq1usq1rCKq1eVr6ZdJOjV0K4zla8Q+YcGMEHM+ptjjbHal8ZWEB3jq/GCrR5RaGLt1dvVMJQTNOZSUsIXgwmW3zTqtfgP7+j8fI5gX6w+1hwZibcc2HJfVvjC2gZU+3KGaALoA47DlR00LaUvLD8T3CK6RUr7MuroTgkcsakK7UY23UnKl91uSr4F7HBf1LP5Nw+cm2iVSXi2sU0AC6w9aSlfYhLxSr2aPd/XVzhIxfN+opCfcQ9/QO/ikgC+Iq/DJ/eZtK8dKl+7IN5HjrWijDhmpPSF5kheL7L3lPKl32G2Ic+yvhatk5n/ZbzBc97hvqwi1t4YVduYMaK5HuwWicIsNr2ErynNumiGBJMDrl+V9P1y2wKAyVKHDfkx/IGqjDasF6w5scNW3Jd1Pf5kea3wZfTRDUEW07XfGYScL5naFxe7tG6Et0bKl5PDjAbGFdZiso0RJHxxdw0/xpc87hMUZEj6iY/uk0ajJl6SIj60O5qMD4tsz3B+mPaFTQvA8D87wZ94Rv4KYA1xkOob9QXEIhCkffVkFrDUxaGIv0ugv2PtXu1LdjTuhLeUr9IQPzTQH7EcEiRQ3C9rThuP8eV00GzIEfXICArFFdqjxgNelCjliz8yWH07oD115ZT53owFe5GXH4RWi/f/4EuLoPBlBGgXyZph7WaKbl1GHAEpr19tWahZ/xDC7KSvLn8Rvjr43YHf+QJaU7o8ylfpDk2HrApmZ1Ff1Qvse1Dq4EU15ou/v3SuRozgK5fB/j4Ua6j01frZ3pkwpc5DYThJG7rSslNAWcoiXEAWUVA2wfv/f9PXpFugRW8FZmC+vjN37pxGTmIf25ychEQEEeQ9Xxp8/ZaXPGGzrGMU4JVNkphSXOLOdFrCukUmASU5jJc2TdLNzmtkuH/MS4OfFq8xTE6/4yV3v1ZUX8mzeWURWJMQgn2+dvgr7PnC1UcExMWDRvZBjxZtyAUcysvMgmgyIB5bOD5hEnzHS/z6Pt6Q36HSJONkRU9l6kpygEQa3ofx4ruYRoezHDzRf7VIyAIYyeAq8Yb6ABtpBBYwP2b6L2JPODR9CfRf2gCJVXvGhou8m0MxhNdIABFF40M6/CoANiILxofYnVHAHq8DqqUpGeZiDK1/pQmiw2c+jBdHbneO3Ccc4LWiT9YCKiuOaePb+nQ+yjyDl/huhXw8MkaweEhxV+DRTArEh/gvj7JtZzP6yMA0eP5+lW5kODvo+aYjKcirhDgqMSy/0YX4mScX/ZXhgjXETofyAvLGjuoLgfFXxR5/WfTnfnq8r4TmN3iqs8bLaZreUN8OovN0nt6LVHD8ZV15JNF/qcmByJLLAV6mdTmqp4qd3+hDXBfd0ZcUNR8l9umsllpwlVFpKNPmQ3nRic2iTLi5vPwos87RLKw0cJ+5ZWh+wxtPn8ELTYekj0K9HXnD+Wn03IYj4UYjFYjnyf/dvFXCn7Hght1v2RgZIJKyCt3GSB2R/KHMcfx0/HP+kHd4sROVJGpjREPIjhjOCwgvFhjL7bjP8KJw6JMltEmXTvKHQnV3Kn/oBqtBXu9OGR/glWFKKAky1LLzh18zjowQtiWIl3x4/tCSKRI/9I14/n4OG/IX+sv8/DRBw8vR7h/y81/vC5HlJW+h0kKgtvzjaS8A0bpaQeG8QC1Bo3o5gw54gSeITcK6T7v1UeNkfr6jUUnFbiA/j3d2kdbnjnjhhl0yct50yJCgNEDOXOJO1zVIMr92fj4ZyM8rDaj06fuTtvjsfO8GRBcZ4uIMnf/C0NZO+4HX8rV3wEsowp1AqHmipAyMdf4ELzBLQqVJSg95CV9OrFFuQFvYjDr/5UrZM7zYT3n5DAqK5rm7Xteb25D5rwl9MR/x6jyYZOCFpp8k4Xg+r8mv55fprKr4vjdHensN/vz0Pnxk3ofUA27TLs1NEymQkCIRRxed4AW62J7UDJtf5qjX/mvCXFaylSCv9ahoSwryWjhlCYyXh7xSXgnl5Z4/hYc14uKpbzYaif2HjAASJpAOlgPzKXP6KkSDHeF29nzlkN6YGoioDXRPm0I8x6PI6zfEPYkEZULtEVnieXlFSdEJ5xO8aFCRXKBjXqQ7x/UsslvDnVi/cWq9Tcovy+4OeXklj1PF4wXQVIdQSnFOdRxyz/hqeAEqm+8lA5/lI01IaT0UMd4oBvLzc/L77rIgorakx/oAyPV8zOuRRwe8Vo88sz6KziZbV/bM9qYpwo6XTdgRGF7WlRePF5BbJOfLcYLNiwUG8w9ZzrWPefU43hU45jV/dIu4WvKAV88v8XhRkQU3sN714ha+NlHC1kfxKZiscMYrzLUeOWC1/fW3Wy4D6Iocrob6uAAiKpOj/ey2kJ6lM5PE8fpDXR/uGF6wY13IY4cXHWxLum5i/In8Ho1+qgGVKnJ5wZyu6yXCy885YuJKOeq97T/E4dtHdzBYb18hzLHzKbioexpqh7zYMhOzvBS25DAfL0xopLWqpAa9bmEyJJZuHK4/VBK6PqJpq0Ue5ql3GG2GGaWlIC84fKomIF5Gj1368EB/flrfi6HHS5WIaYmZ8ZI3XrTg86JieAHhDyQKLvZo5SArrRdhfa8vlteBKC9G6b+HxbsqCtvcmvAitWDP5CLgSpw+H7YMIgupWxM6Kq0WzFB42ZCoEqI7jyzZWiKnH+o4F3Q2o6U5F0dpNzXo/hTDJqtT51pw/Xz5Tx46qjNDY2HbkQ7UKM49Xu+HZUw8v0kelowmXKT18zmnrjJPwoaGW7feQ/+c3MAwfD4lNU8b4FfiQbpQ3bYKMx4Fv1eSbVZPfakE+RcYca7Q8YV/+z4LQkamstl8LAD//fdT0Oky/ocSRogX5h+bbSVjoGBjEDs2Z52haD1OkNdfEVxHa1hywph4R7Hzdj9keRVlcC0Jjut0fILEOcdJBdfbnC95/V1pvKHYxb4Pq4OLSDVVEOvSQrPhtc5D5EGs6Iqen28BVGjGewTcqELy86iKoQkuJRHEuiqvcQYrSgJcRAMI63HoTnTF82FTeUUpXCh+3984L8TdVzcbdj5sprvbXOomi9rrjfFSZSBm/XS39nJXQ4uw82El9XKRuGyat8VLHT/Ib8+cPztRer+tBv7ifNiEAX4tNh9mpDJjnLix2yGLAHlzbgqZ7byxBv68YUpwvxQB/FKphCRtkOPcnlS54dtB5qSaHLgXndovBZoy+J3kIRzVMwCU394WoAKHhUXvhnGRGYrx/eAC4EkL5bX//e/fLgIe0S+VLWXj+Q4yUjf953QsNF2G8Ho955GtgV4FICCK6M7uxV2IpA8vul8lUo1VM+YU0BXz85/gDFUgfIpxXU9opl90v2WjdU/DmfsTqrXj/czvScH957f/2/DrHhTk1QaXk9wugFhUVzuPQ7vg4yQ09vETdkmhgXTB86Tk43lpeR+fhXlRCS0Y4LUzfs1re8QLoBjXRfWUD/LCjXj1xo0qkwzN95buIPH3P5RQPZGfz1+A13xSBrFsXfl8WGkAzpa8ghKIdWGlGiG8GtN4pHyrmpeCvOL32O0q5HzYUZyIul1d63xYYSKDWJcXqvWvku9V2zEvRtfM9zbj9+ENK8irD2LdrND0+ZhXQ2bLecCIR6zFsRbiwOmPhVo/uzyjgogugxbPRa8gWB3/zxWgQAWhbUaDDsMrOME8XjL0uqM289GCtGGsllRmPzaa+4a4LBq+VdN1wbd6xS/Erq+b8MxWLmwFcnOU8S2xnUj7llp/VYEnw1wCts19zndSGD1w7LGIZZ6JkBLMypPs3pz51vTzk6lgwLZZTmljxuWHtvUttZkoeBWgbLu4QJ41fdEN3+qZdYFt8woxbdYmrEsY4JVPe35aEPqIapLF0rN6eYgziNnuq9RjV91oNR8exCYDD+I98qov0kNQHBkdiKte2QLDUsqzCsyJX3QTt4TA7HOJX5C/Gwe7kYmhQWXrVZAuwVKBZ9rccanTI8VGNeTBo8cf+eexKHueOd1G8RH1JFhqedZcgZ017x9+ACWvzWILwqLqWEhtQ1z34dWh8sy51ixBtiB1rW4SJiuuBTJh+ahSxq4SPRCrf7B17AOyrVSO7nfn/OA7tqzcmv2YNrAtuU0s074VKPtCrKVgW4ZpGbjtuFxIxGo6TjJ5y8qXOduimbPOk+OS9Lk40bMt9ZlYddelTqw+sK30iLTSbfM6R1y6+8l8YOIyZVsy/btNDKiFhDZxok95atVeiLUUbZe9InHZRsgGpBGX7jNVKFnW7sN2AujQVko9UkukcUKxx9kuv4jLzxpvA/qEGCpfTgWLBHE5dipY7wiQreOyojC8GH1+GMJgq9lG7mEh1ApuP6dt0oJRrjuWWZmJs4oJMbX+Wh/rbUZO2T5TExYPHdvA/SdVfRo79ZUmcyG7XkFbnWZamBaWjpVoDUTj49Ox9A9D7FVNx3opTIV0U3JcrtY1tfuWtK38mLjsY9vaPSzUaebLTQFYLqcfbpuH71abq0P3Vy2TX3XkuLTbnHS2RuqnVDU1zrtt7qp+mxtWm2vlPYSYVlDticb7q+PklbS5ZToWbfOD02Zllaqp80nOaXM/lZ1m3DYn37pZg7ikkpoLdfbutjlRHagD4pLhFeueFPO6L8W87ksxr/tSzOu+FPO6L8W87ksxr/vSf8d/VnUvifa4AAAAAElFTkSuQmCC"

/***/ }),
/* 264 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/liberal0.94c8cab.png";

/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  this["$style"] = __webpack_require__(199)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(93),
  /* template */
  __webpack_require__(315),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  this["$style"] = __webpack_require__(237)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(95),
  /* template */
  __webpack_require__(355),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  this["$style"] = __webpack_require__(221)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(96),
  /* template */
  __webpack_require__(339),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 269 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(242)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(98),
  /* template */
  __webpack_require__(329),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-5803a3ec",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  this["$style"] = __webpack_require__(218)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(102),
  /* template */
  __webpack_require__(336),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  this["$style"] = __webpack_require__(228)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(105),
  /* template */
  __webpack_require__(346),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  this["$style"] = __webpack_require__(209)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(106),
  /* template */
  __webpack_require__(326),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  this["$style"] = __webpack_require__(214)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(107),
  /* template */
  __webpack_require__(332),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  this["$style"] = __webpack_require__(236)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(108),
  /* template */
  __webpack_require__(354),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 275 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  this["$style"] = __webpack_require__(229)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(109),
  /* template */
  __webpack_require__(347),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  this["$style"] = __webpack_require__(225)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(110),
  /* template */
  __webpack_require__(343),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  this["$style"] = __webpack_require__(201)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(111),
  /* template */
  __webpack_require__(317),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  this["$style"] = __webpack_require__(207)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(112),
  /* template */
  __webpack_require__(324),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  this["$style"] = __webpack_require__(206)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(113),
  /* template */
  __webpack_require__(323),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  this["$style"] = __webpack_require__(216)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(114),
  /* template */
  __webpack_require__(334),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  this["$style"] = __webpack_require__(235)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(115),
  /* template */
  __webpack_require__(353),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  this["$style"] = __webpack_require__(231)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(116),
  /* template */
  __webpack_require__(349),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 283 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  this["$style"] = __webpack_require__(234)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(117),
  /* template */
  __webpack_require__(352),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  this["$style"] = __webpack_require__(222)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(118),
  /* template */
  __webpack_require__(340),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  this["$style"] = __webpack_require__(220)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(119),
  /* template */
  __webpack_require__(338),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  this["$style"] = __webpack_require__(197)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(120),
  /* template */
  __webpack_require__(313),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  this["$style"] = __webpack_require__(215)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(121),
  /* template */
  __webpack_require__(333),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  this["$style"] = __webpack_require__(194)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(122),
  /* template */
  __webpack_require__(310),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  this["$style"] = __webpack_require__(202)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(123),
  /* template */
  __webpack_require__(319),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  this["$style"] = __webpack_require__(224)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(124),
  /* template */
  __webpack_require__(342),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 291 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  this["$style"] = __webpack_require__(211)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(125),
  /* template */
  __webpack_require__(328),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  this["$style"] = __webpack_require__(198)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(126),
  /* template */
  __webpack_require__(314),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 293 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(127),
  /* template */
  __webpack_require__(318),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 294 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  this["$style"] = __webpack_require__(205)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(128),
  /* template */
  __webpack_require__(322),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  this["$style"] = __webpack_require__(193)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(129),
  /* template */
  __webpack_require__(309),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  this["$style"] = __webpack_require__(212)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(131),
  /* template */
  __webpack_require__(330),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  this["$style"] = __webpack_require__(219)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(132),
  /* template */
  __webpack_require__(337),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  this["$style"] = __webpack_require__(208)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(133),
  /* template */
  __webpack_require__(325),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  this["$style"] = __webpack_require__(210)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(134),
  /* template */
  __webpack_require__(327),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  this["$style"] = __webpack_require__(204)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(135),
  /* template */
  __webpack_require__(321),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  this["$style"] = __webpack_require__(227)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(136),
  /* template */
  __webpack_require__(345),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  this["$style"] = __webpack_require__(196)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(137),
  /* template */
  __webpack_require__(312),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  this["$style"] = __webpack_require__(240)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(138),
  /* template */
  __webpack_require__(358),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  this["$style"] = __webpack_require__(217)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(139),
  /* template */
  __webpack_require__(335),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 305 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  this["$style"] = __webpack_require__(213)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(140),
  /* template */
  __webpack_require__(331),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  this["$style"] = __webpack_require__(238)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(141),
  /* template */
  __webpack_require__(356),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  this["$style"] = __webpack_require__(223)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(142),
  /* template */
  __webpack_require__(341),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 308 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-app', [_c('v-toolbar', {
    staticClass: "accent",
    attrs: {
      "app": "",
      "fixed": "",
      "dark": ""
    }
  }, [(_vm.backDst) ? _c('v-toolbar-side-icon', {
    on: {
      "click": function($event) {
        _vm.back()
      }
    }
  }, [_c('v-icon', [_vm._v("arrow_back")])], 1) : (_vm.isStarted) ? _c('v-toolbar-side-icon', {
    on: {
      "click": function($event) {
        _vm.drawer = !_vm.drawer
      }
    }
  }) : _vm._e(), _c('v-toolbar-title', {
    staticClass: "header"
  }, [_vm._v("Secret Hitler")]), _c('v-spacer')], 1), _c('v-navigation-drawer', {
    staticClass: "pb-0",
    attrs: {
      "app": "",
      "temporary": ""
    },
    model: {
      value: (_vm.drawer),
      callback: function($$v) {
        _vm.drawer = $$v
      },
      expression: "drawer"
    }
  }, [_c('v-layout', {
    attrs: {
      "column": "",
      "fill-height": ""
    }
  }, [(_vm.isStarted) ? _c('v-layout', {
    staticClass: "scores",
    attrs: {
      "row": ""
    }
  }, [_c('v-layout', {
    staticClass: "score",
    attrs: {
      "column": "",
      "my-3": "",
      "ml-3": ""
    }
  }, [_c('policy-card', {
    attrs: {
      "policy": "LIBERAL"
    }
  }), _c('span', {
    staticClass: "title pa-3"
  }, [_vm._v(_vm._s(_vm.game.boardState.liberals))])], 1), _c('v-layout', {
    staticClass: "score",
    attrs: {
      "column": "",
      "ma-3": ""
    }
  }, [_c('policy-card', {
    attrs: {
      "policy": "FASCIST"
    }
  }), _c('span', {
    staticClass: "title pa-3"
  }, [_vm._v(_vm._s(_vm.game.boardState.fascists))])], 1)], 1) : _vm._e(), (_vm.isStarted) ? _c('v-layout', {
    staticClass: "election-tracker pb-2"
  }, [_vm._l((3), function(n) {
    return _c('v-layout', {
      key: n,
      attrs: {
        "align-center": "",
        "justify-center": ""
      }
    }, [(_vm.game.boardState.voteFailures == n - 1) ? _c('v-icon', [_vm._v("radio_button_checked")]) : _c('v-icon', [_vm._v("radio_button_unchecked")])], 1)
  }), _c('v-layout', {
    attrs: {
      "align-center": "",
      "justify-center": ""
    }
  }, [_c('v-icon', [_vm._v("error_outline")])], 1)], 2) : _vm._e(), _c('v-list', [_c('v-divider'), _vm._l((_vm.navs), function(arg) {
    return _c('v-list-tile', {
      key: arg.path,
      attrs: {
        "to": (arg.path)
      }
    }, [_c('v-list-tile-action', [_c('v-icon', {
      domProps: {
        "textContent": _vm._s(arg.icon)
      }
    })], 1), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v(_vm._s(arg.label))])], 1)], 1)
  }), (_vm.game) ? _c('v-list-tile', [_c('v-list-tile-action', [_c('v-icon', [_vm._v("videogame_asset")])], 1), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("Game code: " + _vm._s(_vm.game.name))])], 1)], 1) : _vm._e()], 2)], 1)], 1), _c('main', [_c('v-content', {
    staticClass: "content"
  }, [_c('router-view')], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 309 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.state == 'pres_cards') ? _c('president-policies') : (_vm.state == 'chan_cards') ? _c('chancellor-policies') : (_vm.state == 'pres_veto') ? _c('uikit:simple-page', [_c('span', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v("The chancellor has requested a veto")]), _c('v-layout', {
    attrs: {
      "slot": "footer",
      "align-center": "",
      "justify-center": ""
    },
    slot: "footer"
  }, [_c('v-btn', {
    on: {
      "click": function($event) {
        _vm.veto(false)
      }
    }
  }, [_vm._v("Reject veto")]), _c('v-btn', {
    on: {
      "click": function($event) {
        _vm.veto(true)
      }
    }
  }, [_vm._v("Accept veto")])], 1)], 1) : _c('div', {
    staticClass: "legistlature-view"
  }, [(_vm.state == 'pres_waiting') ? _c('div', {
    staticClass: "president"
  }, [_c('div', {
    staticClass: "header"
  }, [_c('span', [_vm._v("Waiting for the chancellor...")])])]) : (_vm.state == 'chan_veto') ? _c('div', {
    staticClass: "chancellor"
  }, [_c('div', {
    staticClass: "header"
  }, [_c('span', [_vm._v("Waiting for the president...")])])]) : (_vm.state == 'chan_waiting') ? _c('div', {
    staticClass: "chancellor"
  }, [_c('div', {
    staticClass: "header"
  }, [_c('span', [_vm._v("Waiting for the president...")])])]) : _c('div', {
    staticClass: "bystander"
  }, [_c('government', {
    attrs: {
      "president": _vm.president,
      "chancellor": _vm.chancellor
    }
  }), _c('div', {
    staticClass: "header"
  }, [_c('span', [_vm._v("The legislature is in session")])])], 1)])
},staticRenderFns: []}

/***/ }),
/* 310 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('uikit:simple-page', [_c('span', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v("Game over!")]), _c('v-layout', {
    attrs: {
      "ma-3": "",
      "column": ""
    }
  }, [(_vm.result == 'FASCIST_HITLER') ? _c('span', {
    staticClass: "info"
  }, [_vm._v("\n            Hitler was elected chancellor\n        ")]) : (_vm.result == 'LIBERAL_HITLER') ? _c('span', {
    staticClass: "info"
  }, [_vm._v("\n            Hitler was assassinated\n        ")]) : (_vm.result == 'FASCIST_POLICY') ? _c('span', {
    staticClass: "info"
  }, [_vm._v("\n            6 fascist policies were enacted\n        ")]) : (_vm.result == 'LIBERAL_POLICY') ? _c('span', {
    staticClass: "info"
  }, [_vm._v("\n            5 liberal policies were enacted\n        ")]) : _vm._e(), _c('v-layout', {
    attrs: {
      "align-center": "",
      "justify-center": ""
    }
  }, [_c('div', {
    staticClass: "policy",
    class: _vm.team
  })])], 1), _c('v-layout', {
    attrs: {
      "slot": "footer",
      "align-center": "",
      "justify-center": ""
    },
    slot: "footer"
  }, [_c('v-btn', {
    on: {
      "click": function($event) {
        _vm.submit()
      }
    }
  }, [_vm._v("Continue")])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 311 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.large) ? _c('v-list', [_vm._t("prefix"), _vm._l((_vm.options), function(player) {
    return _c('v-list-tile', {
      key: player.id,
      staticClass: "large-player",
      attrs: {
        "align-center": "",
        "px-3": "",
        "py-2": ""
      }
    }, [_c('v-list-tile-action', [_vm._t("icon", null, {
      player: player
    })], 2), _c('v-list-tile-title', [_c('span', {
      staticClass: "player-name"
    }, [_vm._v(_vm._s(player.name))])])], 1)
  }), _vm._t("postfix")], 2) : _c('v-layout', {
    attrs: {
      "wrap": "",
      "align-start": "",
      "align-content-start": ""
    }
  }, _vm._l((_vm.options), function(player) {
    return _c('v-layout', {
      key: player.id,
      staticClass: "player",
      attrs: {
        "align-center": "",
        "px-3": "",
        "py-2": ""
      }
    }, [_vm._t("icon", null, {
      player: player
    }), _c('span', {
      staticClass: "player-name ml-3"
    }, [_vm._v(_vm._s(player.name))])], 2)
  }))
},staticRenderFns: []}

/***/ }),
/* 312 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (!_vm.game) ? _c('login-view') : (_vm.isDead) ? _c('dead-view') : (_vm.result) ? _c('result-view', {
    attrs: {
      "result": _vm.result
    }
  }) : (_vm.page) ? _c(_vm.page, {
    tag: "component"
  }) : _c('span', {
    staticClass: "raw"
  }, [_vm._v(_vm._s(_vm.game))])
},staticRenderFns: []}

/***/ }),
/* 313 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-list-tile', {
    on: {
      "click": function($event) {
        _vm.$emit('details')
      }
    }
  }, [_c('v-list-tile-action', [(_vm.args.pass) ? _c('v-icon', {
    staticClass: "icon green--text",
    attrs: {
      "medium": ""
    }
  }, [_vm._v("check")]) : _c('v-icon', {
    staticClass: "icon red--text",
    attrs: {
      "medium": ""
    }
  }, [_vm._v("clear")])], 1), _c('v-list-tile-content', [_c('v-list-tile-title', [(_vm.args.pass) ? _c('span', [_vm._v("The vote passed")]) : _c('span', [_vm._v("The vote failed")]), _c('span', {
    domProps: {
      "textContent": _vm._s(', ')
    }
  }), _c('span', [_vm._v(_vm._s(_vm.args.votes.ja.length) + " to " + _vm._s(_vm.args.votes.nein.length))])]), _c('v-list-tile-sub-title', [_vm._v(_vm._s(_vm.president.name) + " and " + _vm._s(_vm.chancellor.name))])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 314 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('uikit:simple-page', [_c('span', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v("Choose the next president")]), _c('player-selector', {
    attrs: {
      "filter": _vm.filter
    },
    model: {
      value: (_vm.target),
      callback: function($$v) {
        _vm.target = $$v
      },
      expression: "target"
    }
  }), _c('v-layout', {
    attrs: {
      "slot": "footer",
      "align-center": "",
      "justify-center": ""
    },
    slot: "footer"
  }, [_c('v-btn', {
    attrs: {
      "disabled": !_vm.target
    },
    on: {
      "click": function($event) {
        _vm.submit()
      }
    }
  }, [_vm._v("Nominate")])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 315 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('card', {
    attrs: {
      "basis": _vm.basis,
      "card": _vm.card,
      "value": _vm.value,
      "horizontal": _vm.horizontal
    },
    on: {
      "input": function($event) {
        _vm.$emit('input', !_vm.value)
      }
    }
  })
},staticRenderFns: []}

/***/ }),
/* 316 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', {
    attrs: {
      "align-center": "",
      "py-3": "",
      "pl-3": ""
    }
  }, _vm._l((_vm.cards), function(card, i) {
    return _c('v-flex', {
      key: i,
      staticClass: "card-box mr-3"
    }, [_c('policy-card', {
      class: {
        active: _vm.selected.indexOf(i) != -1
      },
      attrs: {
        "policy": card,
        "value": _vm.flipped
      },
      on: {
        "input": function($event) {
          _vm.onClick(i)
        }
      }
    })], 1)
  }))
},staticRenderFns: []}

/***/ }),
/* 317 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-list-tile', [_c('v-list-tile-action', [_c('span', {
    staticClass: "policy",
    class: _vm.policy
  })]), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("A " + _vm._s(_vm.policy) + " policy was enacted")]), (!_vm.args.government) ? _c('v-list-tile-sub-title', [_vm._v("Anarchy")]) : _vm._e()], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 318 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.isPresident) ? _c('action-' + _vm.type, {
    tag: "component",
    attrs: {
      "action": _vm.action
    }
  }) : _c('uikit:simple-page', [(_vm.type == 'bullet') ? _c('span', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v("The president is assassinating someone")]) : _vm._e(), (_vm.type == 'inspect') ? _c('span', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v("The president is investigating someone")]) : _vm._e(), (_vm.type == 'preview-deck') ? _c('span', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v("The president is looking at the top 3 cards of the deck")]) : _vm._e(), (_vm.type == 'special-election') ? _c('span', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v("The president is choosing the next president")]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 319 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('uikit:simple-page', [_c('span', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v("Assassinate a player")]), _c('player-selector', {
    model: {
      value: (_vm.target),
      callback: function($$v) {
        _vm.target = $$v
      },
      expression: "target"
    }
  }), _c('v-layout', {
    attrs: {
      "slot": "footer",
      "align-center": "",
      "justify-center": ""
    },
    slot: "footer"
  }, [_c('v-btn', {
    attrs: {
      "disabled": !_vm.target
    },
    on: {
      "click": function($event) {
        _vm.submit()
      }
    }
  }, [_vm._v("Assassinate")])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 320 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c(_vm.component, {
    tag: "component",
    attrs: {
      "args": _vm.event.args
    }
  })
},staticRenderFns: []}

/***/ }),
/* 321 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('role-assignment')
},staticRenderFns: []}

/***/ }),
/* 322 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('uikit:simple-page', [_c('span', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v("Select a policy to enact")]), _c('policy-selector', {
    attrs: {
      "cards": _vm.session.chancellorCards
    },
    model: {
      value: (_vm.discarding),
      callback: function($$v) {
        _vm.discarding = $$v
      },
      expression: "discarding"
    }
  }), _c('v-layout', {
    attrs: {
      "slot": "footer",
      "align-center": "",
      "justify-center": ""
    },
    slot: "footer"
  }, [(_vm.showVeto) ? _c('v-btn', {
    attrs: {
      "disabled": !_vm.canVeto
    },
    on: {
      "click": function($event) {
        _vm.veto()
      }
    }
  }, [_vm._v("Request veto")]) : _vm._e(), _c('v-btn', {
    attrs: {
      "disabled": !_vm.isReady
    },
    on: {
      "click": function($event) {
        _vm.submit()
      }
    }
  }, [_vm._v("Enact")])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 323 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('role-assignment')
},staticRenderFns: []}

/***/ }),
/* 324 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-list-tile', [_c('v-list-tile-action', [_c('v-icon', {
    attrs: {
      "medium": ""
    }
  }, [_vm._v("visibility")])], 1), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("The deck was inspected")]), _c('v-list-tile-sub-title', [_vm._v(_vm._s(_vm.president.name) + " saw the top 3 cards")])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 325 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.isPresident) ? _c('uikit:simple-page', [_c('span', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v("Nominate a chancellor")]), _c('player-selector', {
    attrs: {
      "filter": _vm.isValid
    },
    model: {
      value: (_vm.selected),
      callback: function($$v) {
        _vm.selected = $$v
      },
      expression: "selected"
    }
  }), _c('v-layout', {
    attrs: {
      "slot": "footer",
      "align-center": "",
      "justify-center": ""
    },
    slot: "footer"
  }, [_c('v-btn', {
    attrs: {
      "disabled": !_vm.selected
    },
    on: {
      "click": function($event) {
        _vm.nominate()
      }
    }
  }, [_vm._v("Nominate")])], 1)], 1) : _c('uikit:simple-page', [_c('span', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v("The president is nominating a chancellor")]), _c('v-flex', {
    attrs: {
      "mt-5": ""
    }
  }, [_c('government', {
    attrs: {
      "president": _vm.president
    }
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 326 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-list-tile', [_c('v-list-tile-action', [_c('v-icon', {
    attrs: {
      "medium": ""
    }
  }, [_vm._v("mdi-emoticon-dead")])], 1), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("An assassination")]), _c('v-list-tile-sub-title', [_vm._v(_vm._s(_vm.president.name) + " assassinated " + _vm._s(_vm.target.name))])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 327 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('uikit:simple-page', {
    attrs: {
      "no-header": ""
    }
  }, [_c('government', {
    attrs: {
      "president": _vm.president,
      "chancellor": _vm.chancellor
    }
  }), (_vm.localPlayer.hasVoted) ? _c('player-list', {
    attrs: {
      "large": "",
      "filter": _vm.filter
    }
  }, [_c('v-list-tile', {
    attrs: {
      "slot": "prefix"
    },
    slot: "prefix"
  }, [_c('v-list-tile-action', [_c('v-icon', {
    staticClass: "icon",
    attrs: {
      "medium": ""
    }
  }, [_vm._v("hourglass_empty")])], 1), _c('v-list-tile-title', [_c('span', {
    staticClass: "header"
  }, [_vm._v("Waiting for votes...")])])], 1)], 1) : _c('v-layout', {
    staticClass: "pl-3",
    attrs: {
      "align-center": "",
      "justify-center": ""
    }
  }, _vm._l(([true, false]), function(val) {
    return _c('v-flex', {
      key: val,
      staticClass: "card-box"
    }, [_c('voting-card', {
      staticClass: "mr-3",
      class: {
        active: _vm.vote === val
      },
      attrs: {
        "vote": val
      },
      on: {
        "input": function($event) {
          _vm.vote = val
        }
      }
    })], 1)
  })), _c('v-layout', {
    attrs: {
      "slot": "footer",
      "align-center": "",
      "justify-center": ""
    },
    slot: "footer"
  }, [(!_vm.localPlayer.hasVoted) ? _c('v-btn', {
    attrs: {
      "disabled": typeof _vm.vote != 'boolean'
    },
    on: {
      "click": function($event) {
        _vm.submit()
      }
    }
  }, [_vm._v("Vote")]) : _vm._e()], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 328 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('uikit:simple-page', [_c('span', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v("These are the top three cards in the deck")]), _c('v-layout', {
    attrs: {
      "align-center": "",
      "pl-3": ""
    }
  }, _vm._l((_vm.action.learned), function(card, i) {
    return _c('policy-card', {
      key: i,
      staticClass: "card",
      attrs: {
        "policy": card
      }
    })
  })), _c('v-layout', {
    attrs: {
      "slot": "footer",
      "align-center": "",
      "justify-center": ""
    },
    slot: "footer"
  }, [_c('v-btn', {
    on: {
      "click": function($event) {
        _vm.complete()
      }
    }
  }, [_vm._v("Ok")])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 329 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "root"
  }, [_c('div', {
    staticClass: "image",
    class: _vm.imageType
  })])
},staticRenderFns: []}

/***/ }),
/* 330 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('uikit:simple-page', [_c('span', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v("Select 2 policies to pass to the chancellor")]), _c('policy-selector', {
    attrs: {
      "cards": _vm.session.presidentCards
    },
    model: {
      value: (_vm.discarding),
      callback: function($$v) {
        _vm.discarding = $$v
      },
      expression: "discarding"
    }
  }), _c('v-layout', {
    attrs: {
      "slot": "footer",
      "align-center": "",
      "justify-center": ""
    },
    slot: "footer"
  }, [_c('v-btn', {
    attrs: {
      "disabled": !_vm.isReady
    },
    on: {
      "click": function($event) {
        _vm.submit()
      }
    }
  }, [_vm._v("Submit")])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 331 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('event-details', {
    attrs: {
      "event": _vm.event
    }
  })
},staticRenderFns: []}

/***/ }),
/* 332 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('uikit:simple-page', {
    attrs: {
      "no-footer": ""
    }
  }, [_c('span', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v(_vm._s(_vm.target.name) + " was investigated")]), _c('government', {
    attrs: {
      "president": _vm.president
    }
  }), _c('v-layout', {
    attrs: {
      "align-center": "",
      "justify-center": ""
    }
  }, [_c('v-icon', {
    staticClass: "icon"
  }, [_vm._v("mdi-magnify")])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 333 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c(_vm.component, {
    tag: "component",
    attrs: {
      "args": _vm.event.args
    },
    on: {
      "details": function($event) {
        _vm.$emit('details')
      }
    }
  })
},staticRenderFns: []}

/***/ }),
/* 334 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('uikit:simple-page', {
    attrs: {
      "no-footer": ""
    }
  }, [_c('span', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v(_vm._s(_vm.target.name) + " was nominated as president by " + _vm._s(_vm.president.name))]), _c('v-layout', {
    attrs: {
      "column": "",
      "justify-center": ""
    }
  }, [_c('government', {
    attrs: {
      "president": _vm.president
    }
  }), _c('v-icon', {
    staticClass: "arrow"
  }, [_vm._v("arrow_downward")]), _c('government', {
    attrs: {
      "president": _vm.target
    }
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 335 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('uikit:simple-page', {
    attrs: {
      "no-header": ""
    }
  }, [_c('event-details', {
    attrs: {
      "event": _vm.result
    }
  }), _c('v-layout', {
    attrs: {
      "slot": "footer",
      "align-center": "",
      "justify-center": ""
    },
    slot: "footer"
  }, [_c('v-btn', {
    on: {
      "click": function($event) {
        _vm.accept()
      }
    }
  }, [_vm._v("Ok")])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 336 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', {
    attrs: {
      "fill-height": "",
      "column": ""
    }
  }, [(!_vm.noHeader) ? _c('div', {
    staticClass: "header mx-3 mt-3"
  }, [_vm._t("header")], 2) : _vm._e(), _c('v-layout', {
    attrs: {
      "column": ""
    }
  }, [_vm._t("default")], 2), (!_vm.noFooter) ? _c('div', {
    staticClass: "pa-3"
  }, [_vm._t("footer")], 2) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 337 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('uikit:simple-page', [_c('span', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v("Game lobby: " + _vm._s(_vm.game.name))]), _c('player-list', {
    scopedSlots: _vm._u([{
      key: "icon",
      fn: function(ref) {
        var player = ref.player;

        return [(player.isReady) ? _c('v-icon', {
          staticClass: "green--text",
          attrs: {
            "medium": ""
          }
        }, [_vm._v("check")]) : _c('v-icon', {
          attrs: {
            "medium": ""
          }
        }, [_vm._v("hourglass_empty")])]
      }
    }])
  }), _c('v-layout', {
    staticClass: "box-container"
  }, [_c('v-flex', {
    staticClass: "box"
  })], 1), _c('v-layout', {
    attrs: {
      "slot": "footer",
      "align-center": "",
      "justify-center": ""
    },
    slot: "footer"
  }, [_c('v-btn', {
    on: {
      "click": function($event) {
        _vm.cancel()
      }
    }
  }, [_vm._v("Cancel")]), (_vm.localPlayer.isReady) ? _c('v-btn', {
    on: {
      "click": function($event) {
        _vm.ready(false)
      }
    }
  }, [_vm._v("Not ready")]) : _c('v-btn', {
    on: {
      "click": function($event) {
        _vm.ready(true)
      }
    }
  }, [_vm._v("Ready")])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 338 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('uikit:simple-page', {
    attrs: {
      "no-header": _vm.args.pass
    }
  }, [(!_vm.args.pass) ? _c('span', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v("The vote failed")]) : _vm._e(), _c('government', {
    attrs: {
      "government": _vm.args
    }
  }), _c('player-list', {
    scopedSlots: _vm._u([{
      key: "icon",
      fn: function(ref) {
        var player = ref.player;

        return [(_vm.getVote(player)) ? _c('v-icon', {
          staticClass: "icon green--text",
          attrs: {
            "medium": ""
          }
        }, [_vm._v("thumb_up")]) : _c('v-icon', {
          staticClass: "icon red--text",
          attrs: {
            "medium": ""
          }
        }, [_vm._v("thumb_down")])]
      }
    }])
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 339 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('card', {
    attrs: {
      "basis": _vm.basis,
      "no-border": "",
      "card": _vm.card,
      "value": _vm.vote != 'back',
      "horizontal": _vm.horizontal
    },
    on: {
      "input": function($event) {
        _vm.$emit('input', _vm.vote)
      }
    }
  })
},staticRenderFns: []}

/***/ }),
/* 340 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-list-tile', [_c('v-list-tile-action', [(_vm.args.agree) ? _c('v-icon', {
    attrs: {
      "medium": ""
    }
  }, [_vm._v("mdi-shield")]) : _c('v-icon', {
    attrs: {
      "medium": ""
    }
  }, [_vm._v("mdi-shield-outline")])], 1), _c('v-list-tile-content', [(_vm.args.agree) ? _c('v-list-tile-title', [_vm._v("The legislature agreed to a veto")]) : _c('v-list-tile-title', [_vm._v("The president denied a veto")])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 341 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "root"
  }, [_c('v-layout', {
    attrs: {
      "justify-center": "",
      "py-3": ""
    }
  }, [_c('v-btn', {
    on: {
      "click": function($event) {
        _vm.abandon()
      }
    }
  }, [_vm._v("Abandon Game")])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 342 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (!_vm.action.target) ? _c('uikit:simple-page', [_c('span', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v("Investigate a player")]), _c('player-selector', {
    attrs: {
      "filter": _vm.filter
    },
    model: {
      value: (_vm.target),
      callback: function($$v) {
        _vm.target = $$v
      },
      expression: "target"
    }
  }), _c('v-layout', {
    attrs: {
      "slot": "footer",
      "align-center": "",
      "justify-center": ""
    },
    slot: "footer"
  }, [_c('v-btn', {
    attrs: {
      "disabled": !_vm.target
    },
    on: {
      "click": function($event) {
        _vm.submit()
      }
    }
  }, [_vm._v("Inspect")])], 1)], 1) : _c('uikit:simple-page', [_c('span', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v(_vm._s(_vm.learned_player.name) + " is " + _vm._s(_vm.learned_result))]), _c('v-layout', {
    attrs: {
      "slot": "footer",
      "align-center": "",
      "justify-center": ""
    },
    slot: "footer"
  }, [_c('v-btn', {
    on: {
      "click": function($event) {
        _vm.finish()
      }
    }
  }, [_vm._v("Ok")])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 343 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('uikit:simple-page', {
    attrs: {
      "no-footer": ""
    }
  }, [_c('span', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v("A " + _vm._s(_vm.policy) + " policy was enacted\n        "), (!_vm.args.government) ? [_vm._v("by anarchy")] : _vm._e()], 2), (_vm.args.government) ? _c('government', {
    attrs: {
      "government": _vm.args.government
    }
  }) : _vm._e(), _c('v-layout', {
    attrs: {
      "column": "",
      "align-center": "",
      "justify-center": ""
    }
  }, [_c('policy-card', {
    staticClass: "card",
    attrs: {
      "basis": "long",
      "policy": _vm.args.policy
    }
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 344 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('card', {
    attrs: {
      "basis": _vm.basis,
      "no-border": "",
      "card": _vm.card,
      "value": _vm.value,
      "horizontal": _vm.horizontal
    },
    on: {
      "input": function($event) {
        _vm.$emit('input', $event)
      }
    }
  })
},staticRenderFns: []}

/***/ }),
/* 345 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('uikit:simple-page', [_c('span', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v("You are dead. Sorry :(")])])
},staticRenderFns: []}

/***/ }),
/* 346 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('uikit:simple-page', {
    attrs: {
      "no-footer": ""
    }
  }, [_c('span', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v(_vm._s(_vm.target.name) + " was shot by " + _vm._s(_vm.president.name))]), _c('v-layout', {
    attrs: {
      "column": ""
    }
  }, [_c('v-flex', {
    staticClass: "art"
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 347 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-list-tile', [_c('v-list-tile-action', [_c('v-icon', {
    attrs: {
      "medium": ""
    }
  }, [_vm._v("supervisor_account")])], 1), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("A government was proposed")]), _c('v-list-tile-sub-title', [_vm._v(_vm._s(_vm.president.name) + " and " + _vm._s(_vm.chancellor.name))])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 348 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.assignment) ? _c('div', {
    staticClass: "role-assignment"
  }, [_c('v-layout', {
    attrs: {
      "py-3": "",
      "pl-3": ""
    }
  }, [_c('role-card', {
    staticClass: "card mr-3",
    attrs: {
      "role": _vm.assignment.role
    },
    model: {
      value: (_vm.roleFlipped),
      callback: function($$v) {
        _vm.roleFlipped = $$v
      },
      expression: "roleFlipped"
    }
  }), _c('membership-card', {
    staticClass: "card mr-3",
    attrs: {
      "role": _vm.assignment.role
    },
    model: {
      value: (_vm.membershipFlipped),
      callback: function($$v) {
        _vm.membershipFlipped = $$v
      },
      expression: "membershipFlipped"
    }
  })], 1), (_vm.roleFlipped) ? _c('v-layout', {
    staticClass: "info px-3"
  }, [(_vm.assignment.role == 'HITLER') ? _c('div', {
    staticClass: "hitler-info"
  }, [_c('span', [_vm._v("You are Hitler")])]) : (_vm.assignment.role == 'FASCIST') ? _c('div', {
    staticClass: "fascist-info"
  }, [_c('span', [_vm._v("You are a fascist")])]) : (_vm.assignment.role == 'LIBERAL') ? _c('div', {
    staticClass: "liberal-info"
  }, [_c('span', [_vm._v("You are a liberal")])]) : _vm._e(), (_vm.hitler) ? _c('div', {
    staticClass: "known"
  }, [_c('span', [_vm._v(_vm._s(_vm.hitler.name) + " is Hitler")])]) : _vm._e(), (_vm.fascists) ? _vm._l((_vm.fascists), function(fascist) {
    return _c('div', {
      key: fascist.id,
      staticClass: "known"
    }, [_c('span', [_vm._v(_vm._s(fascist.name) + " is a fascist")])])
  }) : _vm._e()], 2) : _vm._e()], 1) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 349 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "group"
  }, [_c('v-divider', {
    staticClass: "divider"
  }), _c('v-subheader', {
    attrs: {
      "inset": ""
    }
  }, [_vm._v("Turn " + _vm._s(_vm.args.turn))])], 1)
},staticRenderFns: []}

/***/ }),
/* 350 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "resize",
      rawName: "v-resize",
      value: (_vm.resize),
      expression: "resize"
    }],
    staticClass: "card",
    style: (_vm.style)
  }, [_c('div', {
    staticClass: "rotation",
    class: {
      horizontal: _vm.horizontal
    },
    style: (_vm.rotStyle)
  }, [_c('div', {
    staticClass: "flipper",
    class: {
      flipped: _vm.value, border: !_vm.noBorder
    },
    on: {
      "click": _vm.onClick
    }
  }, [_c('div', {
    staticClass: "front",
    style: (_vm.frontStyle)
  }), _c('div', {
    staticClass: "back",
    style: (_vm.backStyle)
  })])])])
},staticRenderFns: []}

/***/ }),
/* 351 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "scrollable": "",
      "fullscreen": "",
      "transition": "dialog-bottom-transition"
    },
    model: {
      value: (_vm.isOpen),
      callback: function($$v) {
        _vm.isOpen = $$v
      },
      expression: "isOpen"
    }
  }, [_c('v-list', {
    attrs: {
      "slot": "activator"
    },
    slot: "activator"
  }, [_c('v-list-tile', [_c('v-list-tile-action', [(_vm.value) ? _c('v-icon', {
    attrs: {
      "medium": ""
    }
  }, [_vm._v("person")]) : _c('v-icon', {
    attrs: {
      "medium": ""
    }
  }, [_vm._v("person_outline")])], 1), _c('v-list-tile-title', [(_vm.value) ? _c('span', {
    staticClass: "player-name"
  }, [_vm._v(_vm._s(_vm.value.name))]) : _c('span', [_vm._v("Select a player")])])], 1)], 1), _c('v-card', [_c('v-toolbar', [_c('v-toolbar-side-icon', {
    on: {
      "click": function($event) {
        _vm.isOpen = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1), _c('v-toolbar-title', [_vm._v("Select a player")])], 1), _c('v-card-text', {
    staticClass: "dialog-contents"
  }, [_c('v-list', _vm._l((_vm.options), function(player) {
    return _c('v-list-tile', {
      key: player.id,
      on: {
        "click": function($event) {
          _vm.select(player)
        }
      }
    }, [_c('v-list-tile-title', [_c('span', {
      staticClass: "player-name"
    }, [_vm._v(_vm._s(player.name))])])], 1)
  }))], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 352 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('uikit:simple-page', {
    attrs: {
      "no-footer": ""
    }
  }, [(_vm.args.agree) ? _c('span', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v("The legislature agreed to a veto")]) : _c('span', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v("The president denied a veto")]), _c('government', {
    attrs: {
      "government": _vm.args
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 353 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-list-tile', [_c('v-list-tile-action', [_c('v-icon', {
    attrs: {
      "medium": ""
    }
  }, [_vm._v("mdi-alert-octagram")])], 1), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("A special election")]), _c('v-list-tile-sub-title', [_vm._v(_vm._s(_vm.president.name) + " nominated " + _vm._s(_vm.target.name) + " for president")])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 354 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-list-tile', [_c('v-list-tile-action', [_c('v-icon', {
    attrs: {
      "medium": ""
    }
  }, [_vm._v("mdi-magnify")])], 1), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("An investigation")]), _c('v-list-tile-sub-title', [_vm._v(_vm._s(_vm.president.name) + " investigated " + _vm._s(_vm.target.name))])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 355 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('card', {
    attrs: {
      "basis": _vm.basis,
      "card": _vm.card,
      "value": _vm.value,
      "horizontal": _vm.horizontal
    },
    on: {
      "input": function($event) {
        _vm.$emit('input', !_vm.value)
      }
    }
  })
},staticRenderFns: []}

/***/ }),
/* 356 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('uikit:simple-page', {
    attrs: {
      "no-header": "",
      "no-footer": ""
    }
  }, [(_vm.game) ? _c('v-list', {
    staticClass: "my-list",
    attrs: {
      "two-line": ""
    }
  }, _vm._l((_vm.log), function(event, i) {
    return _c('event-preview', {
      key: _vm.log.length - i,
      attrs: {
        "event": event
      },
      on: {
        "details": function($event) {
          _vm.onDetails(event)
        }
      }
    })
  })) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 357 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', {
    staticClass: "ballot",
    attrs: {
      "justify-center": ""
    }
  }, [(_vm.pres) ? _c('v-layout', {
    staticClass: "president",
    attrs: {
      "column": "",
      "justify-center": ""
    }
  }, [_c('plaque', {
    attrs: {
      "president": ""
    }
  }), _c('span', {
    staticClass: "title name"
  }, [_vm._v(_vm._s(_vm.pres.name))])], 1) : _vm._e(), (_vm.chan) ? _c('v-layout', {
    staticClass: "chancellor",
    attrs: {
      "column": "",
      "justify-center": ""
    }
  }, [_c('plaque', {
    attrs: {
      "chancellor": ""
    }
  }), _c('span', {
    staticClass: "title name"
  }, [_vm._v(_vm._s(_vm.chan.name))])], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 358 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', {
    attrs: {
      "column": "",
      "align-center": ""
    }
  }, [_c('div', {
    staticClass: "logo"
  }), _c('v-container', [_c('v-text-field', {
    attrs: {
      "label": "Game code",
      "type": "number"
    },
    model: {
      value: (_vm.gameCode),
      callback: function($$v) {
        _vm.gameCode = $$v
      },
      expression: "gameCode"
    }
  }), _c('v-text-field', {
    attrs: {
      "label": "Name"
    },
    model: {
      value: (_vm.name),
      callback: function($$v) {
        _vm.name = $$v
      },
      expression: "name"
    }
  }), _c('v-layout', {
    attrs: {
      "justify-space-around": "",
      "mt-3": ""
    }
  }, [(!_vm.connection) ? [_c('v-btn', {
    on: {
      "click": function($event) {
        _vm.create()
      }
    }
  }, [_vm._v("Create")]), _c('v-btn', {
    on: {
      "click": function($event) {
        _vm.join()
      }
    }
  }, [_vm._v("Join")])] : (_vm.connection == 'CONNECTING') ? _c('v-progress-circular', {
    attrs: {
      "indeterminate": ""
    }
  }) : _c('span', {
    staticClass: "raw"
  }, [_vm._v(_vm._s(_vm.connection))])], 2), _c('v-layout', {
    attrs: {
      "mt-3": ""
    }
  }, [_c('span', {
    staticClass: "body-1"
  }, [_vm._v("Go to "), _c('a', {
    attrs: {
      "href": "/secret-hitler/spectate/"
    }
  }, [_vm._v("/secret-hitler/spectate/")]), _vm._v(" to get a better view of the game")])])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */
/***/ (function(module, exports) {

module.exports = {"name":"secret-hitler-frontend","version":"1.1.2","description":"A Vue.js project","author":"Max Froehlich <max@mfroehlich.me>","private":true,"scripts":{"dev":"node build/dev-server.js","start":"node build/dev-server.js","build":"node build/build.js"},"dependencies":{"raven-js":"^3.20.1","vue":"^2.5.3","vue-router":"^3.0.1","vuex":"^2.5.0"},"devDependencies":{"@mfro/vue-specific-css":"^1.3.0","autoprefixer":"^7.1.6","babel-core":"^6.22.1","babel-loader":"^7.1.1","babel-plugin-transform-object-rest-spread":"^6.26.0","babel-plugin-transform-runtime":"^6.22.0","babel-preset-env":"^1.6.1","babel-preset-stage-2":"^6.22.0","babel-register":"^6.22.0","chalk":"^2.3.0","copy-webpack-plugin":"^4.2.0","css-loader":"^0.28.0","cssnano":"^3.10.0","eventsource-polyfill":"^0.9.6","express":"^4.16.2","extract-text-webpack-plugin":"^2.0.0","file-loader":"^0.11.1","friendly-errors-webpack-plugin":"^1.1.3","html-webpack-plugin":"^2.28.0","http-proxy-middleware":"^0.17.3","less":"^2.7.3","less-loader":"^4.0.5","opn":"^5.1.0","optimize-css-assets-webpack-plugin":"^2.0.0","ora":"^1.2.0","preload-webpack-plugin":"^2.0.0","rimraf":"^2.6.0","semver":"^5.3.0","shelljs":"^0.7.6","stylus":"^0.54.5","stylus-loader":"^3.0.1","sw-precache-webpack-plugin":"^0.11.4","uglify-es":"^3.1.7","url-loader":"^0.5.8","vue-loader":"^12.1.0","vue-style-loader":"^3.0.1","vue-template-compiler":"^2.5.3","vuetify":"^0.16.9","webpack":"^2.6.1","webpack-bundle-analyzer":"^2.2.1","webpack-dev-middleware":"^1.10.0","webpack-hot-middleware":"^2.20.0","webpack-merge":"^4.1.1","mdi":"^2.0.46"},"engines":{"node":">= 4.0.0","npm":">= 3.0.0"},"browserslist":["> 1%","last 2 versions","not ie <= 8"]}

/***/ }),
/* 363 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./board/fascist_l.png": 252,
	"./board/fascist_m.png": 253,
	"./board/fascist_s.png": 254,
	"./board/liberal.png": 255,
	"./logo.svg": 256,
	"./membership/back.png": 63,
	"./membership/fascist.png": 64,
	"./membership/liberal.png": 65,
	"./misc/box.svg": 257,
	"./misc/dove.svg": 258,
	"./misc/fascist-victory.png": 259,
	"./misc/gun.svg": 260,
	"./misc/liberal-victory.png": 261,
	"./misc/skull.svg": 262,
	"./plaque/chancellor.png": 263,
	"./plaque/president.png": 264,
	"./policy/back.png": 66,
	"./policy/fascist.png": 67,
	"./policy/liberal.png": 68,
	"./role/back.png": 69,
	"./role/fascist0.png": 70,
	"./role/fascist1.png": 71,
	"./role/fascist2.png": 72,
	"./role/hitler0.png": 73,
	"./role/liberal0.png": 265,
	"./role/liberal1.png": 74,
	"./role/liberal2.png": 75,
	"./role/liberal3.png": 76,
	"./role/liberal4.png": 77,
	"./role/liberal5.png": 41,
	"./vote/back.png": 78,
	"./vote/ja.png": 79,
	"./vote/nein.png": 80
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 363;

/***/ }),
/* 364 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./assassination/details.vue": 271,
	"./investigation/details.vue": 273,
	"./policy/details.vue": 276,
	"./role-assignment/details.vue": 279,
	"./special-election/details.vue": 280,
	"./veto/details.vue": 283,
	"./vote/details.vue": 285
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 364;

/***/ }),
/* 365 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./assassination/preview.vue": 272,
	"./investigation/preview.vue": 274,
	"./nomination/preview.vue": 275,
	"./policy/preview.vue": 277,
	"./preview-deck/preview.vue": 278,
	"./special-election/preview.vue": 281,
	"./turn-completed/preview.vue": 282,
	"./veto/preview.vue": 284,
	"./vote/preview.vue": 286
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 365;

/***/ }),
/* 366 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./COMPLETED/index.vue": 288,
	"./EXECUTIVE_ACTION/index.vue": 293,
	"./LEGISLATING/index.vue": 295,
	"./LOBBY/index.vue": 297,
	"./NOMINATING/index.vue": 298,
	"./VOTING/index.vue": 299
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 366;

/***/ })
],[149]);


// WEBPACK FOOTER //
// static/js/player-app.7da3f276e57c081f592c.js